import { IonButton, IonButtons, IonCard, IonCardContent, IonCheckbox, IonChip, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPage, IonPopover, IonRow, IonSearchbar, IonSelect, IonSelectOption, IonTitle, IonToast, IonToolbar, isPlatform, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { addCircle, arrowBack, calendarOutline, checkmarkCircle, closeOutline, ellipsisVertical, locationOutline, map, pricetagsOutline, removeCircle, trash } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { adicionarImpressaoNaFila, criarJobImpressao } from '../../../../../Utils/PrintQueueHelper';
import { codificarTextoComAvancoEscPos, formatarBlocoTextoParaEscPos, sanitizarTextoParaEscPos } from '../../../../../Utils/EscPosText';
import { deveExibirCategoriaNoCupom, normalizarProdutoCupom } from '../../../../../Utils/CupomProduto';
import { empresaCarregar, empresaConfiguracoesAlterar, incluirProjeto, listaEquipePorPerfil, projetoGerarCupom, removerTagsEnderecoEmpresa, requestService, urlBaseCore } from '../../../../../Utils/Services';
import { useGooglePlacesSearch } from '../../../../../components/useGooglePlacesSearch';
import { MessageContext } from '../../../../../contexts/MessageContext';
import Agendamento from '../Agendamento/Agendamento';
import EnderecoTaxa from '../EnderecoTaxa/EnderecoTaxa';
import OrdensProdutosCompor from '../OrdensProdutosCompor/OrdensProdutosCompor';
import './OrdensNovoPedido.css';

type Props = {
  closeAction: Function;
  closeActionSimple: Function;
}

const OrdensNovoPedido: React.FC<Props> = (props: Props) => {
  // Navigation
  const history = useHistory();
  const location = useLocation<any>();

  // Alert and Toast
  const [mostartAlerta] = useIonAlert();
  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);

  // Loading State
  const [showLoading, setShowLoading] = useState(false);

  // Contexts
  const { loja, setLoja } = useContext(MessageContext);
  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);
  // const [dadosEmpresa, setDadosEmpresa] = useState<any>([]);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);
  const { pkUsuario, setPkUsuario } = useContext(MessageContext);

  // State: Loja
  const [lojas, setLojas] = useState<string>(loja);

  // State: Filtro e Listagem
  const [textoFiltro, setTextoFiltro] = useState<any>();
  const [listaItemProdutos, setListaItemProdutos] = useState<any>([]);

  // State: Detalhes do Endereço
  const [showDetalhesEndereco, setShowDetalhesEndereco] = useState(false);
  const inputRefEndereco = useRef<any>(null);
  const [endereco, setEndereco] = useState("");
  const [enderecoLat, setEnderecoLat] = useState("");
  const [enderecoLng, setEnderecoLng] = useState("");
  const [complemento, setComplemento] = useState("");

  const [showModalAgendamento, setShowModalAgendamento] = useState(false);
  const [tipoAgendamento, setTipoAgendamento] = useState("");
  const [dataAgendamento, setDataAgendamento] = useState("");
  const [horaAgendamento, setHoraAgendamento] = useState("");

  // Hook para busca de endereços Google Places (substitui estados antigos)
  const {
    listaEnderecos,
    buscandoEndereco,
    buscarSugestoes: buscarSugestoesEndereco,
    buscarDetalhes: buscarDetalhesEnderecoHook,
    limparSugestoes
  } = useGooglePlacesSearch({
    loja,
    configuracoesEntrega: dadosEmpresa?.configuracoesEntrega,
    onError: (mensagem) => {
      setTextToast(mensagem);
      setShowToast(true);
    },
    onLoading: setShowLoading
  });

  // State: Cliente
  const [pkCliente, setPkCliente] = useState("");
  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");

  // State: Valores e Pagamento
  const [troco, setTroco] = useState<any>('');
  const [valorPagoDinheiro, setValorPagoDinheiro] = useState<any>('');
  const [valorTotal, setValorTotal] = useState<any>();
  const [valorTotalProdutos, setValorTotalProdutos] = useState<any>();
  const [formaPagamento, setFormaPagamento] = useState('');
  const [taxaEntrega, setTaxaEntrega] = useState<any>();
  const [desconto, setDesconto] = useState<any>();
  const [taxaServico, setTaxaServico] = useState<any>();
  const [bairroSelecionado, setBairroSelecionado] = useState<any>();

  const [reloadCatalogo, setReloadCatalogo] = useState(false);

  const parseCurrencyValue = (value: any) => {
    return parseFloat(String(value || '0').replace(/\./g, '').replace(/,/g, '.')) || 0;
  };

  const formatCurrencyValue = (value: number) => {
    return value.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  // Função para obter apenas os bairros das configurações
  const getBairrosConfiguracoes = () => {
    console.log('getBairrosConfiguracoes - dadosEmpresa:', dadosEmpresa);
    console.log('getBairrosConfiguracoes - tipoConfiguracoesEntrega:', dadosEmpresa?.tipoConfiguracoesEntrega);
    console.log('getBairrosConfiguracoes - configuracoesEntrega:', dadosEmpresa?.configuracoesEntrega);

    if (!dadosEmpresa?.configuracoesEntrega) return [];
    return dadosEmpresa.configuracoesEntrega.filter((config: any) => config.tipo === 'bairro' || config.bairro);
  };

  // Função para quando um bairro é selecionado
  const onBairroSelecionado = (bairro: string) => {
    setBairroSelecionado(bairro);
    const config = dadosEmpresa?.configuracoesEntrega?.find((item: any) =>
      (item.tipo === 'bairro' && item.bairro === bairro) ||
      (!item.tipo && item.bairro === bairro)
    );
    if (config) {
      setTaxaEntrega(config.taxa?.toString() || "");
    }
  };

  // Refs
  const campoTelefone = useRef<any>(null);
  const inputRef = useRef<any>(null);
  const contentCatalogoRef = useRef<any>(null);

  // Dados da Empresa
  // const [dadosEmpresa, setDadosEmpresa] = useState<any>([]);

  const [desabilitarInfiniteScroll, setDesabilitarInfiniteScroll] = useState(false);
  const [projetopk, setProjetopk] = useState("");
  const [projetosk, setProjetosk] = useState("");
  const [projetogsi2sk, setProjetogsi2sk] = useState("");
  const [arrayProjetos, setArrayProjetos] = useState<any>([]);


  // utilizado para ver o historico de pedidos
  const [filtroCampoSelecionadoProjeto, setFiltroCampoSelecionadoProjeto] = useState<any>("nome");
  const [filtroStatusProjeto, setFiltroStatusProjeto] = useState<any>("Encerrado");

  const [showModalHistorico, setShowModalHistorico] = useState(false);

  const inputRefTag = useRef<any>(null);
  const [showModalTags, setShowModalTags] = useState(false);
  const [showModalTagsAdd, setShowModalTagsAdd] = useState(false);
  const [listaTagsEndereco, setListaTagsEndereco] = useState<any>();
  const [nomeTag, setNomeTag] = useState("");

  // Estado para armazenar valor persistido no localStorage
  const [impressoraBluetoothHabilitar, setImpressoraBluetoothHabilitar] = useState<boolean>(() => {
    const storedValue = window.localStorage.getItem("impressoraBluetoothHabilitar");
    return storedValue === "true";
  });

  const [impressoraBluetoothSPPHabilitar, setImpressoraBluetoothSPPHabilitar] = useState<boolean>(() => {
    const storedValue = window.localStorage.getItem("impressoraBluetoothSPPHabilitar");
    return storedValue === "true";
  });

  const [impressoraLocalHabilitar, setImpressoraLocalHabilitar] = useState<boolean>(() => {
    const storedValue = window.localStorage.getItem("impressoraLocalHabilitar");
    return storedValue === "true";
  });

  const [impressoraRedeHabilitar, setImpressoraRedeHabilitar] = useState<boolean>(() => {
    const storedValue = window.localStorage.getItem("impressoraRedeHabilitar");
    return storedValue === "true";
  });

  const [showPopover, setShowPopover] = useState(false);
  const [popoverEvent, setPopoverEvent] = useState(null);

  const openPopover = (e: any) => {
    e.persist();
    setPopoverEvent(e);
    setShowPopover(true);
  };

  const closePopover = () => {
    setShowPopover(false);
    setPopoverEvent(null);
  };


  // const opcoesPagamento = [
  //   'Dinheiro',
  //   'Cartão de Crédito',
  //   'Cartão de Débito',
  //   'Pix',
  //   'Alelo',
  //   'Sodexo',
  //   'Vale Alimentação',
  //   // 'Mercado Pago Crédito', 'Mercado Pago Débito', 'Mercado Pago Alelo', 'Mercado Pago Sodexo', 'InfinitePay Crédito', 'InfinitePay Débito'
  // ];

  // Gera opções de taxa de entrega dinamicamente com base em dadosEmpresa.configuracoesEntrega.taxa
  const opcoesTaxaEntregaDefault = [
    { label: 'Grátis', value: '0,00' },
    { label: 'R$ 3,00', value: '3,00' },
    { label: 'R$ 4,00', value: '4,00' },
    { label: 'R$ 5,00', value: '5,00' },
    { label: 'R$ 6,00', value: '6,00' },
    { label: 'R$ 7,00', value: '7,00' },
    { label: 'R$ 8,00', value: '8,00' },
    { label: 'R$ 10,00', value: '10,00' },
    { label: 'R$ 12,00', value: '12,00' },
    { label: 'R$ 15,00', value: '15,00' },
  ];

  const opcoesTaxaEntrega = (() => {
    try {
      // @ts-ignore
      const configuracoes = dadosEmpresa?.configuracoesEntrega;
      if (Array.isArray(configuracoes) && configuracoes.length > 0) {
        const valoresUnicos = new Set<string>();
        configuracoes.forEach((cfg: any) => {
          const taxa = cfg?.taxa;
          if (taxa !== undefined && taxa !== null && taxa !== '') {
            let v = String(taxa).replace('.', ',');
            // normaliza para NN,NN
            if (!v.includes(',')) {
              const n = Number(v);
              v = n.toFixed(2).replace('.', ',');
            }
            valoresUnicos.add(v);
          }
        });

        const lista = Array.from(valoresUnicos).map((v) => ({
          label: v === '0,00' ? 'Grátis' : `R$ ${v}`,
          value: v
        }));

        // garante opção Grátis
        if (!lista.some(o => o.value === '0,00')) {
          lista.unshift({ label: 'Grátis', value: '0,00' });
        }

        if (lista.length > 0) return lista;
      }
    } catch (e) { }
    // fallback
    return [{ label: 'Grátis', value: '0,00' }, ...opcoesTaxaEntregaDefault.filter(o => o.value !== '0,00')];
  })();

  const opcoesDesconto = [
    { label: 'R$ 0,00', value: '0,00' },
    { label: 'R$ 1,00', value: '1,00' },
    { label: 'R$ 2,00', value: '2,00' },
    { label: 'R$ 3,00', value: '3,00' },
    { label: 'R$ 4,00', value: '4,00' },
    { label: 'R$ 5,00', value: '5,00' },
    { label: 'R$ 10,00', value: '10,00' },
    { label: 'R$ 15,00', value: '15,00' },
    { label: 'R$ 20,00', value: '20,00' },
    { label: 'R$ 25,00', value: '25,00' }
  ];

  useEffect(() => {

    try {
      let taxaServicoFloat = parseFloat(taxaServico?.replace(/\./g, '').replace(/\,/g, '.'));
      let descontoFloat = parseFloat(desconto?.replace(/\./g, '').replace(/\,/g, '.'));
      let taxaEntregaFloat = parseFloat(taxaEntrega?.replace(/\./g, '').replace(/\,/g, '.'));

      let valorTotalRecalculado = 0;
      if (valorTotalProdutos) {
        valorTotalRecalculado = parseFloat(valorTotalProdutos.replace(/\./g, '').replace(/\,/g, '.'));
      }

      if (taxaEntrega) {
        valorTotalRecalculado += (taxaEntregaFloat ? taxaEntregaFloat : 0);
      }

      if (desconto) {
        valorTotalRecalculado += - (descontoFloat ? descontoFloat : 0);
      }
      if (taxaServico) {
        valorTotalRecalculado += (valorTotalRecalculado * (taxaServicoFloat / 100));
      }

      setValorTotal(valorTotalRecalculado.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }));

    } catch (error) {
      console.log("erro ao calcular", error);
    }
  }, [taxaEntrega, taxaServico, desconto, valorTotalProdutos]);

  useEffect(() => {
    if (formaPagamento !== 'Dinheiro') {
      setTroco('');
      setValorPagoDinheiro('');
      return;
    }

    if (!valorPagoDinheiro) {
      setTroco('');
      return;
    }

    const valorPagoFloat = parseCurrencyValue(valorPagoDinheiro);
    const valorTotalFloat = parseCurrencyValue(valorTotal);
    const trocoCalculado = Math.max(0, valorPagoFloat - valorTotalFloat);

    setTroco(formatCurrencyValue(trocoCalculado));
  }, [formaPagamento, valorPagoDinheiro, valorTotal]);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    carregarEmpresa();

    if (inputRef.current) {
      inputRef.current.setFocus();
    }

    setPkCliente("");
    setTextoFiltro("");

  })

  function carregarEmpresa() {

    const consultar = async () => {

      requestService(empresaCarregar.url.replace("{id}", loja.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {
        method: empresaCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {

          setDadosEmpresa(response.Item);
          setListaTagsEndereco(response.Item.tagsEndereco || []);

          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }

  const loadTagsEndereco = () => {

    if (listaTagsEndereco == undefined) return;

    if (listaTagsEndereco.length === 0) {
      return (

        <IonItem lines="full" key={"semAgenda"}>

          <IonLabel>
            <h2 style={{ "verticalAlign": "middle" }}><strong>Nenhuma tag cadastrada</strong></h2>
          </IonLabel>

        </IonItem>


      );
    }

    return listaTagsEndereco.map((value: any, index: any) => (
      <IonItem lines="full" key={index}>
        {/* <IonIcon icon={add} slot="start" color="success"> </IonIcon> */}
        <IonLabel>
          {value}
        </IonLabel>
        <IonIcon slot="end" color='primary' icon={trash} onClick={() => { deletarTag(value) }} />



      </IonItem>
    ));
  }

  async function deletarTag(nome: string) {
    const token = localStorage.getItem("token") || "";

    try {
      const resp = await fetch(removerTagsEnderecoEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")), {
        method: removerTagsEnderecoEmpresa.method,
        headers: {
          "Content-Type": "application/json",
          "token": token
        },
        body: JSON.stringify({ nome }),
        credentials: 'include'
      });

      const response = await resp.json();
      console.log("retorno", response);

      if (response?.message?.Attributes) {
        setTextToast("Tag removida com sucesso.");
        setShowToast(true);

        setDadosEmpresa(response.message.Attributes);
        setListaTagsEndereco(response.message.Attributes.tagsEndereco || []);
      }
      else {
        setTextToast("Erro ao remover tag. Tente novamente mais tarde.");
        setShowToast(true);
      }
    } catch (err) {
      console.error("Erro ao remover tag:", err);
      setTextToast("Erro ao remover tag. Tente novamente mais tarde.");
      setShowToast(true);
    }
  }


  function gerarEscPos(projeto: any, imprimir58mm: any = false, fonteGrande: boolean = false) {
    // Função para remover acentos e cedilhas
    function removerAcentosECedilha(texto: string): string {
      return texto
        .normalize('NFD')  // Normaliza o texto para decompô-lo em caracteres base e acentos
        .replace(/[\u0300-\u036f]/g, '')  // Remove os acentos
        .replace(/ç/g, 'c')  // Substitui 'ç' por 'c'
        .replace(/Ç/g, 'C');  // Substitui 'Ç' por 'C'
    }

    // Função para aplicar a máscara de CPF/CNPJ
    function aplicarMascaraCPFouCNPJ(texto: any) {
      if (!texto) return '';
      texto = texto.replace(/\D/g, '');
      if (texto.length === 11) {
        return texto.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (texto.length === 14) {
        return texto.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      return texto;
    }

    // Função para formatar telefone
    function formataTelefone(numero: any) {
      if (numero?.length == 13) {
        let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
        BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
        return BRNumber;
      }
      else if (numero?.length == 12) {
        let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
        BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
        return BRNumber;
      }
      else { return "" };
    }

    function quebrarTextoEmLinhas(texto: any, tamanhoMaximo: any) {
      const conteudo = String(texto || '').trim();
      if (!conteudo) return [];

      const palavras = conteudo.split(/\s+/);
      let linhas = [];
      let linhaAtual = '';

      palavras.forEach((palavra: any) => {
        let restante = String(palavra);

        while (restante.length > 0) {
          const proximaLinha = linhaAtual ? `${linhaAtual} ${restante}` : restante;

          if (proximaLinha.length <= tamanhoMaximo) {
            linhaAtual = proximaLinha;
            restante = '';
          } else if (linhaAtual) {
            linhas.push(linhaAtual);
            linhaAtual = '';
          } else {
            linhas.push(restante.slice(0, tamanhoMaximo));
            restante = restante.slice(tamanhoMaximo);
          }
        }
      });

      if (linhaAtual) {
        linhas.push(linhaAtual);
      }

      return linhas;
    }

    // Função para formatar valores monetários
    const formatarValor = (valor: any) => {
      if (!valor) return '0,00';

      // Remove pontos de milhares e substitui a vírgula decimal por ponto
      const valorNumerico = parseFloat(valor.toString().replace(/\./g, '').replace(',', '.'));

      // Formata o número para o padrão brasileiro
      return valorNumerico.toFixed(2).replace('.', ',');
    };

    // Função para gerar o cabeçalho e as informações do cupom
    function gerarCabecalho(projeto: any, empresa: any) {
      const ESC = 0x1B;  // ESC
      const SUBLINHADO_ON = [ESC, 0x2D, 0x01];
      const SUBLINHADO_OFF = [ESC, 0x2D, 0x00];

      let cabecalhoText = "";

      // Informações da empresa
      cabecalhoText += `${empresa?.empresaNome}\n`;
      cabecalhoText += `CNPJ: ${aplicarMascaraCPFouCNPJ(empresa?.empresaCnpj)}\n`;

      // Endereço da empresa
      quebrarTextoEmLinhas(`Endereço: ${empresa.empresaEndereco}`, imprimir58mm ? 32 : 38).forEach((linha: any) => {
        cabecalhoText += `${linha}\n`;
      });

      cabecalhoText += `Tel: ${formataTelefone(empresa?.empresaTelefone)}\n`;

      // Data e hora do cupom, se disponível
      if (projeto.dataCupom) {
        cabecalhoText += `Data: ${new Date(projeto.dataCupom).toLocaleDateString('pt-BR')} Hora: ${new Date(projeto.dataCupom).toLocaleTimeString('pt-BR')}\n`;
      }

      cabecalhoText += imprimir58mm ? `********************************\n` : `**************************************\n`;

      // Informações do cliente
      cabecalhoText += `${projeto.cliente.nome}\n`;

      // Se o projeto não for interno, exibe informações adicionais do cliente
      if (!projeto.interno) {
        cabecalhoText += `Tel: ${formataTelefone(projeto.cliente?.telefone)}\n`;

        // Endereço do cliente, se disponível
        quebrarTextoEmLinhas(`Endereço: ${[projeto.cliente?.endereco, projeto.cliente?.complemento].filter(Boolean).join(', ') || ""}`, imprimir58mm ? 32 : 38).forEach((linha: any) => {
          cabecalhoText += `${linha}\n`;
        });
      }

      cabecalhoText += imprimir58mm ? `********************************\n` : `**************************************\n`;
      cabecalhoText += "CUPOM NÃO FISCAL\n";

      // Se o projeto não for interno, exibe o nome do projeto
      if (projeto.nomeProjeto) {
        cabecalhoText += imprimir58mm ? `================================\n` : `======================================\n`;
        quebrarTextoEmLinhas(`${empresa?.servicoTipo || "Projeto"}: ${projeto.nomeProjeto}`, imprimir58mm ? 32 : 38).forEach((linha: string) => {
          cabecalhoText += `${String.fromCharCode(...SUBLINHADO_ON)}${linha}${String.fromCharCode(...SUBLINHADO_OFF)}\n`;
        });
        cabecalhoText += imprimir58mm ? `================================\n` : `======================================\n`;
      }

      return cabecalhoText;
    }

    // Função para gerar o corpo do cupom (produtos)
    function gerarProdutos(projeto: any) {
      const ESC = 0x1B;  // ESC
      const SUBLINHADO_ON = [ESC, 0x2D, 0x01];
      const SUBLINHADO_OFF = [ESC, 0x2D, 0x00];

      let produtosText = "";
      const larguraProduto = imprimir58mm ? 32 : 38;

      const adicionarLinhasProduto = (
        texto: string,
        prefixoPrimeiraLinha: string,
        prefixoDemaisLinhas: string = " ".repeat(prefixoPrimeiraLinha.length),
        sublinhar: boolean = false
      ) => {
        const larguraConteudo = Math.max(8, larguraProduto - Math.max(prefixoPrimeiraLinha.length, prefixoDemaisLinhas.length));

        quebrarTextoEmLinhas(texto, larguraConteudo).forEach((linha: string, indiceLinha: number) => {
          const prefixo = indiceLinha === 0 ? prefixoPrimeiraLinha : prefixoDemaisLinhas;

          if (sublinhar) {
            produtosText += `${prefixo}${String.fromCharCode(...SUBLINHADO_ON)}${linha}${String.fromCharCode(...SUBLINHADO_OFF)}\n`;
          } else {
            produtosText += `${prefixo}${linha}\n`;
          }
        });
      };

      produtosText += "QTDE | DESCRIÇÃO\n";
      produtosText += imprimir58mm ? `--------------------------------\n` : `--------------------------------------\n`;

      if (projeto.produtos && Array.isArray(projeto.produtos) && projeto.produtos.length > 0) {
        projeto.produtos.forEach((produto: any) => {
          // Verifica se o produto possui uma descrição complexa
          const itemCupom = normalizarProdutoCupom(produto, deveExibirCategoriaNoCupom(dadosEmpresa, projeto));
          adicionarLinhasProduto(
            `${itemCupom.descricaoPrincipal} (R$ ${formatarValor(itemCupom.valorPrincipal)})`,
            `${produto.quantidade} | `
          );
          itemCupom.detalhes.forEach((detalhe) => {
            if (detalhe.observacao) {
              adicionarLinhasProduto(`Observação: ${detalhe.descricao}`, "  ", "  ", true);
            } else {
              adicionarLinhasProduto(`${detalhe.descricao} (R$ ${formatarValor(detalhe.valor)})`, "  - ", "    ");
            }
          });

          // Adiciona o subtotal de cada produto
          produtosText += `VALOR: R$ ${formatarValor(produto.subtotal)}\n`;
          produtosText += imprimir58mm ? `--------------------------------\n` : `--------------------------------------\n`;
        });

        // Adiciona o total de todos os produtos
        if (projeto.valorTotalProdutos) {
          produtosText += `TOTAL: R$ ${formatarValor(projeto.valorTotalProdutos)}\n`;
        }
      }

      return produtosText;
    }

    // Função para gerar o footer com as informações de pagamento
    function gerarFooter(projeto: any, empresa: any) {
      let pagamentoText = "";
      const larguraRodape = imprimir58mm ? 32 : 38;

      const adicionarLinhasRodape = (texto: string) => {
        quebrarTextoEmLinhas(texto, larguraRodape).forEach((linha: string) => {
          pagamentoText += `${linha}\n`;
        });
      };

      const linhasFormaPagamento = Array.isArray(projeto.formaPagamento)
        ? projeto.formaPagamento
          .map((fp: any) => {
            const nome = sanitizarTextoParaEscPos(fp?.pagamento || fp?.formaPagamentoNome || fp?.tipo);
            const valor = fp?.valor ?? fp?.formaPagamentoValor;

            if (!nome) {
              return "";
            }

            return `${String(nome).toUpperCase()}: R$ ${formatarValor(valor)}`;
          })
          .filter(Boolean)
        : [];

      if (projeto.pedidoIfood) {
        pagamentoText += imprimir58mm ? `*************iFood**************\n` : `****************iFood*****************\n`;

        if (projeto.taxas) {
          pagamentoText += `TAXAS: +R$ ${formatarValor(projeto.taxas)}\n`;
        }

        if (projeto.localizadorIfood) {
          pagamentoText += `LOCALIZADOR IFOOD: ${projeto.localizadorIfood}\n`;
        }

        if (projeto.tipoEntrega) {
          pagamentoText += `TIPO DE ENTREGA: ${projeto.tipoEntrega}\n`;
        }

        if (projeto.horarioEntrega) {
          pagamentoText += `HORÁRIO DE ENTREGA: ${projeto.horarioEntrega}\n`;
        }

        if (projeto.extraInfo) {
          adicionarLinhasRodape(`INFORMAÇÕES EXTRAS: ${projeto.extraInfo}`);
        }
      }

      if (projeto.extraInfo && !projeto.pedidoIfood && !projeto.pedido99Food) {
        adicionarLinhasRodape(`INFORMAÇÕES EXTRAS: ${projeto.extraInfo}`);
      }

      // Forma de pagamento
      if (projeto.formaPagamento) {
        if (!Array.isArray(projeto.formaPagamento)) {
          pagamentoText += imprimir58mm ? `********************************\n` : `**************************************\n`;
          const linhaPagamento = projeto.formaPagamento?.toLowerCase() === "dinheiro" && projeto.valorPagoDinheiro
            ? `DINHEIRO: R$ ${formatarValor(projeto.valorPagoDinheiro)}`
            : `PAGAMENTO: ${sanitizarTextoParaEscPos(projeto.formaPagamento).toUpperCase()}`;

          adicionarLinhasRodape(linhaPagamento);
        }
        else if (linhasFormaPagamento.length > 0) {
          pagamentoText += imprimir58mm ? `********************************\n` : `**************************************\n`;
          pagamentoText += `PAGAMENTOS:\n`;
          linhasFormaPagamento.forEach((linha: string) => adicionarLinhasRodape(linha));
        }
      }

      // Troco, se houver
      if (projeto.troco && projeto.troco !== "0,00") {
        pagamentoText += `TROCO: R$ ${formatarValor(projeto.troco)}\n`;
      }

      // Taxa de entrega, se houver
      if (projeto.taxaEntrega) {
        pagamentoText += `TAXA DE ENTREGA: +R$ ${formatarValor(projeto.taxaEntrega)}\n`;
      }

      // Desconto, se houver
      if (projeto.desconto) {
        pagamentoText += `DESCONTO: -R$ ${formatarValor(projeto.desconto)}\n`;
      }

      // Valor total, se houver
      if (projeto.valorTotal) {
        pagamentoText += imprimir58mm ? `********************************\n` : `**************************************\n`;
        pagamentoText += `TOTAL ${empresa.servicoTipo?.toUpperCase() || "PROJETO"}: R$ ${formatarValor(projeto.valorTotal)}\n`;
      }

      return formatarBlocoTextoParaEscPos(pagamentoText, larguraRodape);
    }

    function gerarQrCode(pk: string): string {
      let qrCodeText = "";

      // Comando de inicialização do QR Code
      qrCodeText += "\x1D\x28\x6B"; // Comando inicial
      qrCodeText += "\x04\x00\x31\x41\x32\x00"; // Configuração do modelo do QR (modelo 2)

      qrCodeText += "\x1D\x28\x6B"; // Tamanho dos módulos
      qrCodeText += "\x03\x00\x31\x43\x07"; // Define tamanho como 7

      // Comando para armazenar os dados
      qrCodeText += "\x1D\x28\x6B" +
        String.fromCharCode(pk.length + 3) + "\x00\x31\x50\x30" + pk;

      // Comando para imprimir o QR Code
      qrCodeText += "\x1D\x28\x6B\x03\x00\x31\x51\x30";

      return qrCodeText;
    }

    try {


      console.log("dadosImpressao1");
      // Montando o cupom com os dados no formato ESC/POS
      const cabecalho = gerarCabecalho(projeto, dadosEmpresa);

      console.log("cabecalho", cabecalho);
      const produtos = gerarProdutos(projeto);
      console.log("produtos", produtos);
      const rodape = gerarFooter(projeto, dadosEmpresa);
      console.log("rodape", rodape);
      const qrCodeGerado = gerarQrCode(projeto.pk);
      console.log("qrCodeGerado", qrCodeGerado);
      // Comandos ESC/POS básicos

      const ESC = 0x1B;  // ESC
      const LF = 0x0A;   // Line Feed
      const GS = 0x1D;
      const CORTA_PAPEL = [ESC, 0x69];   // Corta Papel
      const NEGRITO_ON = [ESC, 0x45, 0x01];  // Ativar negrito
      const NEGRITO_OFF = [ESC, 0x45, 0x00]; // Desativar negrito
      const ALIMENTAR_PAPEL = [ESC, 0x64, 0x10]; // Alimentação de papel
      const FONTE_NORMAL = [GS, 0x21, 0x00];
      const FONTE_GRANDE = [GS, 0x21, 0x01]; // 2x altura


      const dadosImpressao: any = [
        // ...ALIMENTAR_PAPEL, // Alimentação de papel
        LF,
        ...(fonteGrande ? FONTE_GRANDE : FONTE_NORMAL),
        ...NEGRITO_ON,
        ...removerAcentosECedilha(cabecalho).split("").map(c => c.charCodeAt(0)),
        ...NEGRITO_OFF, // Desativar negrito
        LF, // Pular linha
        ...removerAcentosECedilha(produtos).split("").map(c => c.charCodeAt(0)),
        LF, // Pular linha
        ...codificarTextoComAvancoEscPos(rodape),
        LF, // Pular linha
        ...qrCodeGerado.split("").map(c => c.charCodeAt(0)),
        ...FONTE_NORMAL,
        LF, LF, LF, LF, LF,
        // ...ALIMENTAR_PAPEL, // Alimentação de papel
        ...CORTA_PAPEL

      ];

      // Retorna os dados como Uint8Array
      return new Uint8Array(dadosImpressao);
    } catch (error) {
      console.error('Erro ao imprimir cupom:', error);
      return null; // Retorna null em caso de erro
    }
  }

  function validarCampos() {

    const valorTotalNum = parseFloat(valorTotal?.replace(/\./g, '').replace(/,/g, '.') || '0');

    if (nome.length == 0) {
      setTextToast("Campo Nome é obrigatório.");
      setShowToast(true);
      return false;
    }
    else if (telefone.length != 15 && telefone.length != 14) {
      setTextToast("Campo Telefone é obrigatório.");
      setShowToast(true);
      return false;
    }
    else if (endereco.length == 0) {
      setTextToast("Campo Endereço é obrigatório.");
      setShowToast(true);
      return false;
    }
    else if (listaItemProdutos.length == 0) {
      setTextToast("Adicione pelo menos um item.");
      setShowToast(true);
      return false;
    }
    else if (!formaPagamento) {
      setTextToast("Campo Forma de pagamento é obrigatório.");
      setShowToast(true);
      return false;
    }
    else if (!taxaEntrega) {
      setTextToast("Campo Taxa de entrega é obrigatório.");
      setShowToast(true);
      return false;
    }
    else if (valorTotalNum <= 0) {
      setTextToast('O valor total do pedido deve ser maior que zero.');
      setShowToast(true);
      return;
    }

    return true;
  }

  function avancar(pularEndereco: boolean = false) {

    if (!validarCampos())
      return;

    setShowLoading(true);

    console.log("enderecoLat", enderecoLat);
    console.log("enderecoLng", enderecoLng);

    let objRequest = {
      "nomeCliente": nome,
      "telefoneCliente": "55" + telefone.replace("(", "").replace(")", "").replace(" ", "").replace("-", ""),
      lojas: JSON.parse(window.localStorage.getItem("lojas") || "[]").filter((value: any) => {
        return lojas.includes(value.empresaLojaId);
      }),
      "pularEndereco": endereco === "RETIRADA" ? true : pularEndereco,
      "endereco": endereco + (bairroSelecionado ? `, ${bairroSelecionado}` : "") || "",
      "complemento": complemento || "",
      "enderecoLat": enderecoLat,
      "enderecoLng": enderecoLng,
      "clienteid": pkCliente.replaceAll(/#/g, '%23'),
      "empresaid": loja || "",
      "responsaveis": [pkUsuario.replaceAll(/#/g, '%23')],
      "interno": false,
      "produtos": listaItemProdutos,
      "formaPagamento": formaPagamento,
      "valorPagoDinheiro": formaPagamento === "Dinheiro" ? valorPagoDinheiro : "",
      "troco": troco,
      "taxaEntrega": taxaEntrega,
      "desconto": desconto,
      "taxaServico": taxaServico,
      "agendamento": tipoAgendamento == "AGENDADO"
        ? "AGENDADO | " + formatarData(dataAgendamento) + " às " + formatarHora(horaAgendamento)
        : ""

    };

    requestService(incluirProjeto.url, {
      method: incluirProjeto.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      body: JSON.stringify(objRequest),
      credentials: 'include'
    },
      history,
      async (response: any) => {




        if (response.message && response.message.pk) {

          // atualiza estoque
          // if (response.data) {
          //   setDadosEmpresa(response.data)
          // }
          // console.log("response", response);

          // gerarEscPos(response.message.vo);
          // return;

          const quantidadeImpressoes = dadosEmpresa.impressaoDuasVias ? 2 : 1;

          // === NOVO: SISTEMA DE FILA DE IMPRESSÃO ===
          const comandosEscPos = gerarEscPos(response.message.vo, (dadosEmpresa.impressoraLargura == "58" ? true : false), dadosEmpresa.tamanhoFonte === "grande");
          if (comandosEscPos) {
            const mobile = !isPlatform('mobileweb') && isPlatform('mobile');

            let tipo: 'ble' | 'spp' | 'rede' | 'local' | null = null;
            let config: any = {};

            if (impressoraRedeHabilitar && mobile) {
              tipo = 'rede';
              config = { ip: dadosEmpresa.impressoraRedeIp, porta: dadosEmpresa.impressoraRedePorta };
            } else if (impressoraLocalHabilitar && !mobile) {
              tipo = 'local';
              config = { printerName: window.localStorage.getItem("impressoraLocalName") || "" };
            } else if (impressoraBluetoothHabilitar && mobile) {
              tipo = 'ble';
              config = { deviceId: window.localStorage.getItem("impressoraBluetoothDeviceId") };
            } else if (impressoraBluetoothSPPHabilitar && isPlatform('android') && mobile) {
              tipo = 'spp';
              config = { address: window.localStorage.getItem("impressoraBluetoothSPPAddress") };
            }

            if (tipo) {
              const adicionado = adicionarImpressaoNaFila(criarJobImpressao({
                comandosEscPos,
                dados: response.message.vo,
                impressoraConfig: config,
                tipo,
                quantidadeVias: quantidadeImpressoes,
                origem: 'OrdensNovoPedido:incluir'
              }));

              if (adicionado) {
                console.log('📋 [NOVOPEDIDO] Adicionado na fila');
                history.goBack();
                return; // Sucesso - não executar código legado
              }
            }
          }
          // === FIM DO SISTEMA DE FILA ===

          // if (dadosEmpresa.impressoraRedeHabilitar && (!isPlatform('mobileweb') && isPlatform('mobile'))) {
          //   const ipImpressora = dadosEmpresa.impressoraRedeIp;
          //   const portaImpressora = dadosEmpresa.impressoraRedePorta;

          //   const conectarEEnviar = () => {
          //     // Cria o socket TCP
          //     window.chrome.sockets.tcp.create({}, (createInfo) => {
          //       const socketId = createInfo.socketId;

          //       // Define o timeout para mostrar a mensagem de erro após 3 segundos
          //       const timeoutId = setTimeout(() => {
          //         setTextToast("Erro ao conectar.");
          //         setShowToast(true);
          //         window.chrome.sockets.tcp.close(socketId);
          //       }, 3000); // 3 segundos

          //       // Tenta conectar ao IP e porta especificados
          //       window.chrome.sockets.tcp.connect(socketId, ipImpressora, portaImpressora, (result) => {
          //         if (result === 0) {
          //           // Conexão bem-sucedida, cancela o timeout
          //           clearTimeout(timeoutId);

          //           console.log('Conexão bem-sucedida! Enviando dados...');

          //           const comandosEscPos = gerarEscPos(response.message.vo, (dadosEmpresa.impressoraLargura == "58" ? true : false));
          //           if (comandosEscPos) {
          //             window.chrome.sockets.tcp.send(socketId, comandosEscPos.buffer, (sendInfo) => {
          //               console.log('Comando enviado com sucesso:', sendInfo);
          //               window.chrome.sockets.tcp.close(socketId);
          //             });
          //           } else {
          //             console.error('Erro ao gerar ESC/POS');
          //           }
          //         } else {
          //           // Conexão falhou, cancela o timeout e mostra mensagem de erro
          //           clearTimeout(timeoutId);
          //           console.error(`Erro ao conectar à impressora. Verifique a conexão.`);
          //           setTextToast("Erro ao conectar.");
          //           setShowToast(true);
          //           window.chrome.sockets.tcp.close(socketId);
          //         }
          //       });
          //     });
          //   };


          //   // Chame a função com o URL do HTML que você deseja imprimir
          //   for (let i = 0; i < quantidadeImpressoes; i++) {
          //     conectarEEnviar();
          //   }
          // }
          // else if (impressoraLocalHabilitar && !(!isPlatform('mobileweb') && isPlatform('mobile'))) {

          //   console.log("*********************impressao browser pela rede");
          //   const ipImpressora = dadosEmpresa.impressoraRedeIp;
          //   const portaImpressora = dadosEmpresa.impressoraRedePorta;



          //   const conectarEEnviar = () => {
          //     // Cria o socket TCP


          //     console.log('Conexão bem-sucedida! Enviando dados...');

          //     const comandosEscPos: any = gerarEscPos(response.message.vo, (dadosEmpresa.impressoraLargura == "58" ? true : false));

          //     if (comandosEscPos) {
          //       // Exemplo de uso
          //       const resultadoString = converterParaString(comandosEscPos);
          //       // const resultadoString = arrayToEscapedString(comandosEscPos);
          //       //console.log(resultadoString);




          //       const printerName = window.localStorage.getItem("impressoraLocalName") || "";

          //       enviarImpressao(printerName, resultadoString);




          //     } else {
          //       console.error('Erro ao gerar ESC/POS');
          //     }

          //   };


          //   // Chame a função com o URL do HTML que você deseja imprimir
          //   for (let i = 0; i < quantidadeImpressoes; i++) {
          //     conectarEEnviar();
          //   }


          // }
          // else if (impressoraBluetoothHabilitar && (!isPlatform('mobileweb') && isPlatform('mobile'))) {
          //   const comandosEscPos = gerarEscPos(response.message.vo, (dadosEmpresa.impressoraLargura == "58" ? true : false));
          //   if (comandosEscPos) {
          //     const PRINT_SERVICE_UUID = "000018f0-0000-1000-8000-00805f9b34fb";
          //     const PRINT_CHARACTERISTIC_UUID = "00002af1-0000-1000-8000-00805f9b34fb";
          //     // Fragmentar os dados em pacotes menores
          //     const chunkSize = 20; // Tamanho máximo permitido por pacote BLE
          //     const buffer = comandosEscPos.buffer;

          //     const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

          //     try {
          //       const impressoraBluetoothDeviceId = window.localStorage.getItem("impressoraBluetoothDeviceId");

          //       if (!impressoraBluetoothDeviceId) {
          //         setTextToast("Nenhum dispositivo BLE configurado.");
          //         setShowToast(true);
          //         return;
          //       }

          //       // Verifica se já está conectado
          //       let isConnected = false;
          //       try {
          //         const connectedDevices = await BleClient.getConnectedDevices([]);
          //         isConnected = connectedDevices.some(device => device.deviceId === impressoraBluetoothDeviceId);
          //         console.log('Estado inicial da conexão BLE:', isConnected ? 'CONECTADO' : 'DESCONECTADO');
          //       } catch (checkError) {
          //         console.log('Não conectado (verificação falhou):', checkError);
          //         isConnected = false;
          //       }

          //       if (!isConnected) {
          //         // Tenta conectar ao dispositivo
          //         console.log('Iniciando conexão BLE com:', impressoraBluetoothDeviceId);
          //         await BleClient.connect(impressoraBluetoothDeviceId);
          //         console.log('Conexão BLE estabelecida!');

          //         // Aguarda estabilização
          //         await delay(1000);
          //       } else {
          //         console.log('BLE já conectado, reutilizando conexão existente');
          //       }

          //       // Loop externo para múltiplas vias
          //       for (let via = 0; via < quantidadeImpressoes; via++) {
          //         // Loop para enviar os dados em pacotes
          //         for (let i = 0; i < buffer.byteLength; i += chunkSize) {
          //           const chunk = new DataView(buffer.slice(i, Math.min(i + chunkSize, buffer.byteLength)));
          //           await BleClient.write(
          //             impressoraBluetoothDeviceId || "",
          //             PRINT_SERVICE_UUID,
          //             PRINT_CHARACTERISTIC_UUID,
          //             chunk
          //           );
          //           await delay(50); // Atraso de 50ms entre os envios
          //         }

          //         // Delay entre vias
          //         if (via < quantidadeImpressoes - 1) {
          //           await delay(2000);
          //         }
          //       }

          //       setTextToast("Impressão realizada com sucesso!");
          //       setShowToast(true);

          //     } catch (error: any) {
          //       console.error("Erro durante a impressão BLE:", error);
          //       setTextToast(error.message || "Erro ao realizar a impressão BLE.");
          //       setShowToast(true);

          //       // NÃO desconecta em caso de erro - mantém conexão para próximas tentativas
          //     }
          //   } else {
          //     console.error('Erro ao gerar ESC/POS');
          //   }
          // }
          // else if (impressoraBluetoothSPPHabilitar && isPlatform('android') && (!isPlatform('mobileweb') && isPlatform('mobile'))) {
          //   const comandosEscPos = gerarEscPos(response.message.vo, (dadosEmpresa.impressoraLargura == "58" ? true : false));
          //   if (comandosEscPos) {
          //     try {
          //       const impressoraBluetoothSPPAddress = window.localStorage.getItem("impressoraBluetoothSPPAddress");

          //       if (!impressoraBluetoothSPPAddress) {
          //         setTextToast("Nenhum dispositivo SPP configurado.");
          //         setShowToast(true);
          //         return;
          //       }

          //       // Verifica se já está conectado
          //       let isConnected = false;
          //       try {
          //         isConnected = await BluetoothSerial.isConnected();
          //         console.log('Estado inicial da conexão SPP:', isConnected ? 'CONECTADO' : 'DESCONECTADO');
          //       } catch (checkError) {
          //         console.log('Não conectado (isConnected falhou):', checkError);
          //         isConnected = false;
          //       }

          //       if (!isConnected) {
          //         // Conecta ao dispositivo
          //         console.log('Iniciando conexão SPP com:', impressoraBluetoothSPPAddress);

          //         await new Promise<void>((resolve, reject) => {
          //           let connectionTimeout: any;

          //           // Subscribe para monitorar dados
          //           BluetoothSerial.subscribe('\n').subscribe(
          //             (data: any) => {
          //               console.log('Subscribe SPP recebeu dados:', data);
          //             },
          //             (error: any) => {
          //               console.log('Erro no subscribe SPP:', error);
          //             }
          //           );

          //           // Timeout de 10 segundos
          //           connectionTimeout = setTimeout(() => {
          //             BluetoothSerial.disconnect();
          //             reject(new Error('Timeout: não foi possível conectar à impressora em 10 segundos.'));
          //           }, 10000);

          //           // Conecta
          //           BluetoothSerial.connect(impressoraBluetoothSPPAddress).subscribe(
          //             async () => {
          //               clearTimeout(connectionTimeout);
          //               console.log('Callback de conexão SPP executado!');

          //               // Aguarda estabilização
          //               await new Promise(r => setTimeout(r, 1500));

          //               try {
          //                 // Verifica conexão
          //                 const isNowConnected = await BluetoothSerial.isConnected();
          //                 console.log('Estado após conectar SPP:', isNowConnected ? 'CONECTADO' : 'DESCONECTADO');

          //                 if (!isNowConnected) {
          //                   throw new Error('Impressora não conectou. Verifique se está ligada.');
          //                 }

          //                 resolve();
          //               } catch (err) {
          //                 reject(err);
          //               }
          //             },
          //             (error: any) => {
          //               clearTimeout(connectionTimeout);
          //               console.error('Erro ao conectar SPP:', error);
          //               reject(new Error(`Falha na conexão: ${error}`));
          //             }
          //           );
          //         });
          //       } else {
          //         console.log('SPP já conectado, reutilizando conexão existente');
          //       }

          //       // Impressão em loop se for duas vias (conexão já está ativa)
          //       for (let via = 0; via < quantidadeImpressoes; via++) {
          //         // Converte Uint8Array para string (sem fragmentação)
          //         const dataString = Array.from(comandosEscPos)
          //           .map(byte => String.fromCharCode(byte))
          //           .join('');

          //         // Envia todos os dados de uma vez
          //         console.log(`Enviando via ${via + 1}/${quantidadeImpressoes}:`, comandosEscPos.length, 'bytes para a impressora SPP...');
          //         await BluetoothSerial.write(dataString);
          //         console.log('Dados SPP enviados com sucesso!');

          //         // Aguarda processamento entre vias
          //         if (via < quantidadeImpressoes - 1) {
          //           await new Promise(resolve => setTimeout(resolve, 2000));
          //         }
          //       }

          //       setTextToast("Impressão realizada com sucesso!");
          //       setShowToast(true);

          //     } catch (error: any) {
          //       console.error("Erro durante a impressão SPP:", error);
          //       setTextToast(error.message || "Erro ao realizar a impressão SPP.");
          //       setShowToast(true);

          //       // NÃO desconecta em caso de erro - mantém conexão para próximas tentativas
          //     }
          //   } else {
          //     console.error('Erro ao gerar ESC/POS');
          //   }
          // }
          // else {
          gerarCupom(response.message.pk);
          // }
          history.goBack();
          // }
          // else {




          //   mostartAlerta({
          //     backdropDismiss: false,
          //     header: 'Cadastro realizado com sucesso',
          //     message: 'Deseja imprimir?',

          //     buttons: [{
          //       text: 'Cancelar',
          //       role: 'cancel',
          //       handler: () => {
          //         history.goBack();
          //       }
          //     },
          //     {
          //       text: 'Confirmar',
          //       handler: async () => {

          //         await openNewTabWithHTML(response.message.vo);
          //         history.goBack();
          //       }
          //     }],
          //     onDidDismiss: () => { console.log('did dismiss'); }
          //   })

          // }




        }

      },
      (error: any) => {
        console.log(error);




        mostartAlerta({
          backdropDismiss: false,
          header: 'Endereço com problema',
          message: error.message,

          buttons: [{
            text: 'Cancelar',
            role: 'cancel',
          },
          {
            text: 'Confirmar',
            handler: () => {
              avancar(true);
            }
          }],
          onDidDismiss: () => { console.log('did dismiss'); }
        })
      }).finally(() => {
        setShowLoading(false);
      });




  }


  function converterParaString(dadosImpressao: any) {
    return String.fromCharCode(...dadosImpressao.filter((byte: any) => byte <= 0xFF)); // Filtrando valores válidos
  }

  async function enviarImpressao(printer: any, data: any) {

    const url = "http://localhost:9100/print";

    // Montando o corpo da requisição no formato necessário
    var raw = JSON.stringify({
      "printer": printer,
      "data": data,  // Dados no formato correto (com códigos ESC/POS)
    });

    try {
      // Configurações da requisição
      const requestOptions: any = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: 'follow',
      };

      // Envia a requisição utilizando fetch
      const resp = await fetch(url, requestOptions);

      // Aguardar a resposta como texto
      const result = await resp.text();

      if (result) {
        console.log("Impressão enviada com sucesso:", result);
      } else {
        console.error("Erro: Nenhuma resposta recebida.");
      }
    } catch (error) {
      console.error("Erro ao enviar dados para a impressora:", error);
    }
  }

  async function gerarCupom(projetoid: any) {


    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    setShowLoading(true);
    const resp = await fetch(projetoGerarCupom.url.replaceAll("{id}", projetoid.replaceAll(/#/g, "%23")),
      {
        method: projetoGerarCupom.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    const result = await resp.json();
    if (result) {

      mostartAlerta({
        backdropDismiss: false,
        header: 'Gerar Cupom',
        message: '<strong>Cupom</strong> foi gerado com sucesso.',
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
          },
          {
            text: 'Visualizar',
            cssClass: 'primary',
            handler: () => {
              window.open(result, '_blank');
            }
          }
        ],
        onDidDismiss: (e) => console.log('did dismiss'),
      })

    }

    setShowLoading(false);

  }

  // const handleSelectItemEndereco = (item: any) => {

  //   try {

  //     console.log("item", item);

  //     // setEndereco(item.formatted_address);
  //     setEnderecoLat(item.geometry.location.lat);
  //     setEnderecoLng(item.geometry.location.lng);
  //     setTaxaEntrega(item.taxaEntrega);
  //     // setTempoEntregaSelecionado(item.tempoEntrega);

  //     setListaEnderecos([]);

  //     if (!item.taxaEntrega) {
  //       setTextToast("Fora da área de entrega.");
  //       setShowToast(true);
  //       return;
  //     }

  //     setTextToast("Endereço localizado com sucesso.");
  //     setShowToast(true);

  //   } catch (error) {
  //     console.log("erro ao localizar", error);
  //   }

  // };

  // Função para lidar com seleção de item da lista de sugestões (apenas para raio)
  const handleSelectItemSugestaoEndereco = (item: any) => {
    try {
      console.log("item selecionado sugestão", item);
      buscarDetalhesEndereco(item.placeId, item.descricao);
    } catch (error) {
      console.log("erro ao selecionar item", error);
    }
  };

  const handleSelectItem = (item: any) => {

    setNome(item.nome);
    setTelefone(formataTelefone(item.telefone));
    setComplemento(item.complemento);
    setPkCliente(item.pk);

    // Lógica diferente para bairro vs raio
    if (dadosEmpresa?.tipoConfiguracoesEntrega === "bairro") {
      console.log("🏘️ Tipo: BAIRRO - Tentando extrair bairro do endereço");

      // Obtém lista de bairros configurados
      const bairrosDisponiveis = getBairrosConfiguracoes().map((config: any) =>
        config.bairro?.toLowerCase()
      ).filter(Boolean);

      console.log("📋 Bairros disponíveis:", bairrosDisponiveis);

      let enderecoSemBairro = item.endereco;
      let bairroEncontrado: string | null = null;

      // Tenta encontrar o bairro no endereço
      const enderecoLower = item.endereco.toLowerCase(); for (const bairro of bairrosDisponiveis) {
        // Verifica se o bairro está presente no endereço
        if (enderecoLower.includes(bairro)) {
          bairroEncontrado = bairro;

          // Remove o bairro do endereço (case insensitive)
          const regex = new RegExp(`,?\\s*${bairro}\\s*,?`, 'gi');
          enderecoSemBairro = item.endereco.replace(regex, '')
            .replace(/,\s*,/g, ',') // Remove vírgulas duplicadas
            .replace(/^,\s*|,\s*$/g, '') // Remove vírgulas no início/fim
            .trim();

          console.log("✅ Bairro encontrado:", bairro);
          console.log("📍 Endereço sem bairro:", enderecoSemBairro);
          break;
        }
      }

      // Seta o endereço sem o bairro
      setEndereco(enderecoSemBairro);
      setEnderecoLat(item.enderecoLat || "");
      setEnderecoLng(item.enderecoLng || "");

      // Se encontrou o bairro, seleciona automaticamente e carrega o frete
      if (bairroEncontrado) {
        // Busca o bairro original (com case correto) na configuração
        const configBairro = getBairrosConfiguracoes().find((config: any) =>
          config.bairro?.toLowerCase() === bairroEncontrado
        );

        if (configBairro) {
          const bairroOriginal = configBairro.bairro;
          console.log("🎯 Selecionando bairro:", bairroOriginal);

          // Seleciona o bairro e carrega a taxa automaticamente
          setBairroSelecionado(bairroOriginal);
          onBairroSelecionado(bairroOriginal);

          // setTextToast(`Bairro "${bairroOriginal}" selecionado automaticamente`);
          // setShowToast(true);
        }
      } else {
        console.log("⚠️ Nenhum bairro encontrado no endereço");
        setBairroSelecionado(null);
        setTaxaEntrega("");
      }

    } else {
      // Lógica original para tipo RAIO
      console.log("📍 Tipo: RAIO - Calculando taxa por distância");

      setEndereco(item.endereco);
      setEnderecoLat(item.enderecoLat);
      setEnderecoLng(item.enderecoLng);

      // buscar taxa com base na lat e lng
      const distancia = haversine(item.enderecoLat, item.enderecoLng, dadosEmpresa.empresaLatitude, dadosEmpresa.empresaLongitude);

      let novoRaioSelecionado: number | null = null;

      if (distancia >= 8 && distancia <= 12) {
        novoRaioSelecionado = 12;
      } else {
        let menorDistancia = Infinity;

        let raios = [0.5, 1, 1.5, 2, 2.5, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        raios.forEach(raio => {
          if (distancia <= raio) {
            const diferenca = Math.abs(distancia - raio);
            if (diferenca < menorDistancia) {
              menorDistancia = diferenca;
              novoRaioSelecionado = raio;
            }
          }
        });
      }

      console.log("novoRaioSelecionado", novoRaioSelecionado);
      if (novoRaioSelecionado !== null) {
        const raioSelecionado = novoRaioSelecionado;
        const configuracoes = [...(dadosEmpresa?.configuracoesEntrega || [])];

        // Ordena por raio em ordem crescente
        configuracoes.sort((a, b) => parseFloat(a.raio) - parseFloat(b.raio));

        const config = configuracoes.find((item: any) => parseFloat(item.raio) >= raioSelecionado);

        console.log("Taxa correspondente:", config?.taxa?.toString() || "");
        setTaxaEntrega(config?.taxa?.toString() || "");
      } else {
        console.log("Nenhum raio correspondente encontrado.");
        setTaxaEntrega("");
      }
    }
  };

  function haversine(lat1: number, lon1: number, lat2: number, lon2: number) {
    const R = 6371; // Raio da Terra em km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distância em km
  }

  const buscarCliente = async (clienteTelefone: any) => {

    if (clienteTelefone && (clienteTelefone.length == 11 || clienteTelefone.length == 10)) {
      let listaClientes = await buscarClienteDynamoDb(clienteTelefone);

      if (Array.isArray(listaClientes) && listaClientes.length > 0) {
        handleSelectItem(listaClientes[0]);
      }
      else {
        mostartAlerta({
          backdropDismiss: false,
          header: 'Cliente não cadastrado',
          message: 'O cliente não está cadastrado. Deseja criar um novo cadastro?',

          buttons: [{
            text: 'Cancelar',
            role: 'cancel',
          },
          {
            text: 'Confirmar', handler: () => {
              setTelefone(formataTelefone("55" + textoFiltro));
              setNome("");
              setEndereco("");
              setEnderecoLat("");
              setEnderecoLng("");
              setComplemento("");
              setPkCliente("");
            }
          }],
          onDidDismiss: () => { console.log('did dismiss'); }
        })

      }
    }

  }

  const buscarClienteDynamoDb = async (clienteTelefone: any) => {

    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    // const filtro = "?status=ativo#55" + clienteTelefone
    const filtro = "?telefone=telefone#55" + clienteTelefone
    let montarUrl = listaEquipePorPerfil.url.replace("{loja}", loja).concat(filtro).replaceAll(/#/g, "%23").concat("&lojas=" + Buffer.from(loja).toString('base64'));

    const resp = await fetch(montarUrl.replace("{perfil}", "cliente"),
      {
        method: "GET",
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    let equipe = await resp.json();
    if (resp.status === 400 || resp.status === 401) {
      history.replace("/login/");
    }
    else {
      if (equipe.Items) {
        return equipe.Items;
      }
    }
  }


  // function buscarLocalizacao(endereco: any) {

  //   if (endereco.replace(/\s/g, "") == "") {
  //     setTextToast('Endereço é obrigatório.');
  //     setShowToast(true);
  //     return;
  //   }
  //   // else if (numero.replace(/\s/g, "") == "") {
  //   //   setTextToast('Número é obrigatório.');
  //   //   setShowToast(true);
  //   //   return;
  //   // }



  //   let enderecoTratado = endereco.toLowerCase().replace(/\s/g, "+");
  //   console.log("enderecoTratado", enderecoTratado);

  //   const empresaid = loja || "";
  //   console.log("empresaid", empresaid);

  //   const urlCompleta = buscarEnderecoTaxa.url.replace("{id}", empresaid.replace(/#/g, '%23')).replace("{endereco}", enderecoTratado);
  //   console.log("buscarEndereco.url", urlCompleta);


  //   setShowLoading(true);
  //   requestService(urlCompleta, {

  //     method: buscarEnderecoTaxa.method,
  //     headers: [
  //       ["token", window.localStorage.getItem("token")]
  //     ],
  //     credentials: 'include'
  //   },
  //     history,
  //     (response: any) => {
  //       console.log("***response", response);
  //       if (response && response.Item) {
  //         try {

  //           setTextToast("Endereço localizado com sucesso.");
  //           setShowToast(true);

  //           setEndereco(endereco);
  //           setEnderecoLat(response.Item.enderecoLat);
  //           setEnderecoLng(response.Item.enderecoLng);
  //           setTaxaEntrega(response.Item.taxaEntrega);
  //           // setTempoEntregaSelecionado(response.Item.tempoEntrega);

  //         } catch (error) {
  //           console.log("erro ao localizar", error);
  //         }

  //       }
  //     },
  //     (error: any) => {
  //       console.log("e1", error);
  //       // error.message.message usado quando retorna mais de um endereco
  //       if (!error.message.mensagemVariosEnderecos) {
  //         setTextToast(error.message);
  //         setShowToast(true);
  //       }
  //       if (error.message.data) {
  //         console.log("entrou varios endereços");
  //         if (Array.isArray(error.message.data) && error.message.data.length > 0) {

  //           // setListaEnderecos(error.message.data); // Funcionalidade antiga - usar Google Places
  //         }
  //       }
  //     }).finally(() => { setShowLoading(false); });

  // }

  // Função para buscar detalhes do endereço selecionado (usa o hook)
  const buscarDetalhesEndereco = async (placeId: string, enderecoFormatado: string) => {
    try {
      const detalhes = await buscarDetalhesEnderecoHook(placeId, enderecoFormatado);

      // Preencher campos automaticamente
      setEndereco(detalhes.endereco);
      setEnderecoLat(detalhes.latitude);
      setEnderecoLng(detalhes.longitude);

      // Sempre atualizar taxa (mesmo que vazia para fora da área)
      setTaxaEntrega(detalhes.taxaEntrega || "");

    } catch (error) {
      console.error("Erro ao buscar detalhes:", error);
      // Limpar taxa em caso de erro
      setTaxaEntrega("");
    }
  };

  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return "" };
  }

  // Função para formatar a data no padrão brasileiro
  function formatarData(isoDate: string): string {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    const dia = String(date.getDate()).padStart(2, '0');
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const ano = date.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  // Função para formatar a hora
  function formatarHora(isoTime: string): string {
    if (!isoTime) return "";
    // Extrair a parte da hora do formato ISO (2025-12-01T18:10)
    const timePart = isoTime.includes('T') ? isoTime.split('T')[1] : isoTime;
    const [hora, minuto] = timePart.split(':');
    return `${hora}:${minuto}`;
  }

  // async function closeModalEndereco(enderecoSelecionado: any, latitudeSelecionado: any, enderecoLngSelecionado: any) {
  //   console.log("enderecoSelecionado", enderecoSelecionado);
  //   console.log("latitudeSelecionado", latitudeSelecionado);
  //   console.log("enderecoLngSelecionado", enderecoLngSelecionado);

  //   setEndereco(enderecoSelecionado);
  //   setEnderecoLat(latitudeSelecionado);
  //   setEnderecoLng(enderecoLngSelecionado);

  //   setShowDetalhesEndereco(false);
  // }

  async function closeModalEndereco(enderecoSelecionado: any, latitudeSelecionado: any, enderecoLngSelecionado: any, taxaEntregaSelecionado: any, tempoEntregaSelecionado: any) {
    console.log("enderecoSelecionado", enderecoSelecionado);
    console.log("latitudeSelecionado", latitudeSelecionado);
    console.log("enderecoLngSelecionado", enderecoLngSelecionado);
    console.log("taxaEntregaSelecionado", taxaEntregaSelecionado);
    console.log("tempoEntregaSelecionado", tempoEntregaSelecionado);

    setEndereco(enderecoSelecionado);
    setEnderecoLat(latitudeSelecionado);
    setEnderecoLng(enderecoLngSelecionado);
    setTaxaEntrega(taxaEntregaSelecionado);

    // setTempoEntrega(tempoEntregaSelecionado);

    // setComplemento(complementoSelecionado || "");

    setShowDetalhesEndereco(false);
  }

  async function closeModalSimpleEndereco() {
    setShowDetalhesEndereco(false);
  }

  async function closeModalAgendamentoSimple() {
    setShowModalAgendamento(false);
  }

  async function closeModalAgendamento(dataAgendamento: any, horaAgendamento: any, tipoAgendamento: any) {
    setShowModalAgendamento(false);
    setTipoAgendamento(tipoAgendamento);
    setDataAgendamento(dataAgendamento);
    setHoraAgendamento(horaAgendamento);
    // localStorage.setItem("tipoAgendamento", tipoAgendamento);
    // localStorage.setItem("dataAgendamento", dataAgendamento);
    // localStorage.setItem("horaAgendamento", horaAgendamento);

    // if (!endereco) {
    //   setShowDetalhesEndereco(true);
    // }
  }

  function onKeyUpTelefone(e: any) {

    e.persist();
    e.preventDefault();



    let val = e.target.value;

    if (val.length > 15) {
      val = val.substring(0, 15);
      setTelefone(val.substring(0, 15));
      return;
    }
    if (val.length < 15) {

      setTelefone(val
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d)/, "$1-$2")
        .replace(/(-\d{4})(\d+?)$/, "$1"));
    }
    else {

      setTelefone(val
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2")
        .replace(/(-\d{4})(\d+?)$/, "$1"));
    }


  }

  function deletarItemProdutos(index: number) {
    // Filtra a lista de produtos, removendo o item com o índice fornecido
    const updatedList = listaItemProdutos.filter((_: any, i: any) => i !== index);

    // Atualiza a lista de produtos com o item removido
    setListaItemProdutos(updatedList);

    // Calcula a nova soma dos valores após a remoção
    const totalValor = updatedList.reduce((total: any, item: any) => {
      const itemValorNumerico = parseFloat(
        item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
      );
      return total + itemValorNumerico;
    }, 0);

    // Exemplo: você pode armazenar a nova soma em outro estado ou usar conforme necessário
    console.log("Nova soma dos valores:", totalValor);

    setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }));

  }

  function onChangeValor(e: any) {

    e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    // Define o desconto como zero se o campo estiver vazio
    if (v === '') {
      v = '';
    }

    setValorPagoDinheiro(v);
  }

  const loadItemProdutos2 = () => {

    if (listaItemProdutos == undefined) return;

    if (listaItemProdutos.length === 0) {
      return (
        <>
          <IonItem lines="none">

            <IonLabel>
              <h2 style={{ "verticalAlign": "middle" }}><strong>Nenhum item cadastrado</strong></h2>
            </IonLabel>

          </IonItem>
        </>

      );
    }


    return (
      <>

        <IonGrid>
          {listaItemProdutos.map((value: any, index: any) => (
            <>

              <IonRow style={{ borderColor: '#dddddd', borderWidth: '1px', borderBottomStyle: 'dashed' }}>


                <IonCol size="9">


                  {(value.descricao && Array.isArray(value.descricao)) ? (

                    <>
                      {(value.tipo === "pizzas") ? (
                        <div>{value.tamanho} {value.quantidadeSabores} SABORES</div>
                      ) : (
                        <div>{value.categoria}</div>
                      )}
                      {value.descricao.map((item: any, index: number) => (
                        <div key={"desc" + index}>
                          {item.categoria === "Observação" ? (
                            <div style={{ textDecoration: "underline" }}>
                              Observação: {item.descricao}
                            </div>
                          ) : (
                            <div>
                              - {item.descricao}{" "}
                              <IonLabel style={{ textAlign: "right", fontSize: "12px" }}>
                                R$ {item.valor?.toLocaleString("pt-br", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </IonLabel>
                            </div>
                          )}
                        </div>
                      ))}
                    </>

                  ) : (
                    <div key={"desc" + index}>
                      {value.descricao} (<IonLabel style={{ textAlign: "right", fontSize: "12px" }}>R$ {value.valor?.toLocaleString('pt-br', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}</IonLabel>)

                    </div>
                  )}



                </IonCol>


                <IonCol style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }} sizeXs="3" >
                  <IonLabel style={{ textAlign: "right" }}>{value.subtotal}</IonLabel>
                </IonCol>
                <IonCol sizeSm='6'>
                  <IonLabel style={{ textAlign: "right", fontSize: "12px" }} >
                    <IonChip style={{ margin: 0, padding: '5px' }}>
                      <IonIcon size='large' color='danger' icon={removeCircle} onClick={() => {

                        // Faz uma cópia da lista atual de produtos
                        let updatedList = [...listaItemProdutos];

                        // Acessa o item que será atualizado
                        let itemToUpdate = { ...updatedList[index] };

                        // Formata a quantidade atual
                        const quantidadeFormatada = parseFloat(
                          itemToUpdate.quantidade.toString().replace(/\./g, '').replace(/\,/g, '.')
                        );

                        if (quantidadeFormatada > 1) {
                          // Decrementa a quantidade
                          let quantidadeNova = quantidadeFormatada - 1;

                          // Formata o valor e calcula o novo valor com base na nova quantidade
                          const valorFormatado = parseFloat(
                            itemToUpdate.valor.toString().replace(/\./g, '').replace(/\,/g, '.')
                          );

                          // Atualiza a quantidade e o valor do item
                          itemToUpdate.quantidade = quantidadeNova;
                          const valorFloat = quantidadeNova * valorFormatado;

                          itemToUpdate.subtotal = valorFloat.toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          });

                          // Substitui o item atualizado na lista copiada
                          updatedList[index] = itemToUpdate;

                          let totalValor = updatedList.reduce((total: any, item: any) => {
                            const itemValorNumerico = parseFloat(
                              item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
                            );
                            return total + itemValorNumerico;
                          }, 0);

                          setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }));

                          // Atualiza o estado com a nova lista
                          setListaItemProdutos(updatedList);

                        }
                        // else {
                        //   // Se a quantidade for 1, pode-se optar por remover o item completamente ou manter o valor como está.
                        //   // Se preferir remover o item:
                        //   updatedList.splice(index, 1);
                        //   setListaItemProdutos(updatedList);
                        // }

                      }}></IonIcon>
                      <IonLabel style={{ fontSize: '20px' }}>{value.quantidade.toLocaleString('pt-br', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      })}</IonLabel>
                      <IonIcon size='large' color='success' icon={addCircle} onClick={() => {

                        // Faz uma cópia da lista atual de produtos
                        let updatedList = [...listaItemProdutos];

                        // Acessa o item que será atualizado
                        let itemToUpdate = { ...updatedList[index] };

                        // Formata e incrementa a quantidade
                        const quantidadeFormatada = parseFloat(
                          itemToUpdate.quantidade.toString().replace(/\./g, '').replace(/\,/g, '.')
                        );

                        let quantidadeNova = quantidadeFormatada + 1;

                        // Formata o valor e calcula o novo valor com base na nova quantidade
                        const valorFormatado = parseFloat(
                          itemToUpdate.valor.toString().replace(/\./g, '').replace(/\,/g, '.')
                        );

                        // Atualiza a quantidade e o valor do item
                        itemToUpdate.quantidade = quantidadeNova;
                        const valorFloat = quantidadeNova * valorFormatado;

                        itemToUpdate.subtotal = valorFloat.toLocaleString('pt-br', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        });

                        // Substitui o item atualizado na lista copiada
                        updatedList[index] = itemToUpdate;

                        let totalValor = updatedList.reduce((total: any, item: any) => {
                          const itemValorNumerico = parseFloat(
                            item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
                          );
                          return total + itemValorNumerico;
                        }, 0);

                        setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }));

                        // Atualiza o estado com a nova lista
                        setListaItemProdutos(updatedList);


                      }}></IonIcon>
                    </IonChip>
                  </IonLabel>
                </IonCol>
                <IonCol style={{ display: "flex", justifyContent: "flex-end" }} sizeSm='6'>
                  <IonButtons>
                    <IonButton
                      onClick={() => {
                        mostartAlerta({
                          backdropDismiss: false,
                          header: 'Remover item',
                          message: 'Deseja <strong>remover</strong>?',
                          buttons: [
                            {
                              text: 'Cancelar',
                              role: 'cancel',
                            },
                            {
                              text: 'Confirmar',
                              cssClass: 'primary',
                              handler: () => {
                                deletarItemProdutos(index);
                              }
                            }
                          ],
                          onDidDismiss: (e) => console.log('did dismiss'),
                        });
                      }}
                    >
                      <IonIcon color="primary" icon={trash} />
                    </IonButton>
                  </IonButtons>
                </IonCol>

              </IonRow>
            </>
          ))}
        </IonGrid>
      </>
    );
  }

  const scrollToCatalogo = () => {
    contentCatalogoRef.current && contentCatalogoRef.current.scrollIntoView();
  };

  async function adicionarItem(produto: any) {

    if (produto) {

      let updatedList = [...listaItemProdutos, produto];

      setListaItemProdutos(updatedList);

      let totalValor = updatedList.reduce((total: any, item: any) => {
        const itemValorNumerico = parseFloat(
          item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
        );
        return total + itemValorNumerico;
      }, 0);

      setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }));


    }
    scrollToCatalogo();
  }

  /** Normaliza um valor para string formatada pt-BR (ex: "32,00") */
  const normalizarValorString = (valor: any): string => {
    if (valor === undefined || valor === null || valor === '') return '0,00';
    if (typeof valor === 'number') {
      return valor.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    // Já é uma string — garante formato correto
    const num = parseFloat(valor.toString().replace(/\./g, '').replace(/,/g, '.'));
    if (isNaN(num)) return '0,00';
    return num.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const loadItemProdutosHistorico = (produtos: any) => {

    if (produtos == undefined) return;

    if (produtos.length === 0) {
      return (
        <div style={{ padding: '12px 16px', color: 'var(--ion-color-medium)', fontSize: '14px' }}>
          Nenhum item neste pedido
        </div>
      );
    }


    return (
      <div style={{ padding: '0 4px' }}>
        {produtos.map((value: any, index: any) => (
          <div key={"hist-prod-" + index} style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            padding: '6px 0',
            borderBottom: index < produtos.length - 1 ? '1px dashed #eee' : 'none'
          }}>
            <div style={{ flex: 1 }}>
              {(value.descricao && Array.isArray(value.descricao)) ? (
                <>
                  {(value.tipo === "pizzas") ? (
                    <div style={{ fontWeight: 600, fontSize: '14px' }}>
                      {value.quantidade}x {value.tamanho} {value.quantidadeSabores} SABORES
                    </div>
                  ) : (
                    <div style={{ fontWeight: 600, fontSize: '14px' }}>
                      {value.quantidade}x {value.categoria}
                    </div>
                  )}
                  {value.descricao.map((item: any, idx: number) => (
                    <div key={"hd" + idx} style={{ fontSize: '13px', color: '#666', paddingLeft: '8px' }}>
                      {item.categoria === "Observação" ? (
                        <span style={{ fontStyle: 'italic' }}>Obs: {item.descricao}</span>
                      ) : (
                        <span>- {item.descricao} <span style={{ color: '#999' }}>R$ {item.valor?.toLocaleString("pt-br", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></span>
                      )}
                    </div>
                  ))}
                </>
              ) : (
                <div style={{ fontWeight: 600, fontSize: '14px' }}>
                  {value.quantidade}x {value.descricao}
                  <span style={{ fontWeight: 'normal', color: '#999', fontSize: '12px' }}>
                    {' '}(R$ {value.valor?.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})
                  </span>
                </div>
              )}
            </div>
            <div style={{ fontWeight: 600, fontSize: '14px', minWidth: '70px', textAlign: 'right', whiteSpace: 'nowrap' }}>
              {normalizarValorString(value.subtotal)}
            </div>
          </div>
        ))}
      </div>
    );
  }

  const loadItensHistorico = () => {
    if (!arrayProjetos || arrayProjetos.length === 0) {
      return (
        <div style={{ textAlign: 'center', padding: '40px 20px', color: 'var(--ion-color-medium)' }}>
          <p style={{ fontSize: '16px' }}>Sem histórico de pedidos</p>
        </div>
      );
    }

    return arrayProjetos.map((value: any, index: any) => {
      const dataFormatada = new Date(value.dataCadastro).toLocaleString('pt-BR').substring(0, 10);
      const nomePedido = (window.localStorage.getItem("servicoTipo") || "Pedido") + " " + value.nomeProjeto;
      const temDesconto = value.desconto && parseFloat(value.desconto.toString().replace(/\./g, '').replace(/,/g, '.')) > 0;
      const temTaxa = value.taxaEntrega && parseFloat(value.taxaEntrega.toString().replace(/\./g, '').replace(/,/g, '.')) > 0;

      return (
        <IonCard key={"divprojeto" + index} style={{ margin: '8px 0', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
          <IonCardContent style={{ padding: '12px' }}>
            {/* Header do pedido */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '8px',
              paddingBottom: '8px',
              borderBottom: '1px solid #eee'
            }}>
              <div>
                <div style={{ fontSize: '13px', color: 'var(--ion-color-medium)' }}>{dataFormatada}</div>
                <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{nomePedido}</div>
              </div>
              <IonButton
                fill='clear'
                size='default'
                onClick={() => copiarPedido(value)}
                style={{ '--padding-start': '8px', '--padding-end': '8px' }}
              >
                <IonIcon icon={checkmarkCircle} color="primary" style={{ fontSize: '28px' }} />
              </IonButton>
            </div>

            {/* Produtos */}
            {loadItemProdutosHistorico(value.produtos)}

            {/* Desconto e taxa */}
            {(temDesconto || temTaxa) && (
              <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '16px',
                padding: '6px 0 0',
                fontSize: '13px',
                color: 'var(--ion-color-medium)'
              }}>
                {temTaxa && (
                  <span>Taxa: +R$ {normalizarValorString(value.taxaEntrega)}</span>
                )}
                {temDesconto && (
                  <span style={{ color: 'var(--ion-color-success)' }}>Desconto: -R$ {normalizarValorString(value.desconto)}</span>
                )}
              </div>
            )}

            {/* Total */}
            <div style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              paddingTop: '8px',
              marginTop: '4px',
              borderTop: '1px solid #eee'
            }}>
              <span style={{ fontSize: '16px', fontWeight: 'bold', color: 'var(--ion-color-primary)' }}>
                Total: R$ {normalizarValorString(value.valorTotal)}
              </span>
            </div>
          </IonCardContent>
        </IonCard>
      );
    });

  };

  const copiarPedido = (pedido: any) => {

    setListaItemProdutos(pedido.produtos);
    setFormaPagamento(pedido.formaPagamento);
    // setTaxaEntrega(pedido.taxaEntrega);
    setDesconto(pedido.desconto);
    setValorTotalProdutos(pedido.valorTotalProdutos);
    setValorTotal(pedido.valorTotal);

    setShowModalHistorico(false);
  };

  async function carregarProjetosSegmentadaData(filtro: any, data: any, lojasParam?: any) {
    const consultar = async () => {

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      console.log("valor", data);
      console.log("filtroCampoSelecionadoProjeto", filtroCampoSelecionadoProjeto);
      let valor = data;
      if (data) {
        valor = data.replaceAll(/#/g, "%23");
      }
      const resp: Response = await fetch(urlBaseCore.url + "/ordens?campo=" + (filtroCampoSelecionadoProjeto || "data") +
        "&valor=" + valor +
        "&filtro=" + filtro +
        "&lojas=" + Buffer.from(lojasParam || loja).toString('base64'),
        {
          method: urlBaseCore.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        });
      await resp.json().then(async (res) => {
        if (resp.status === 400 || resp.status === 401) {
          setShowLoading(false);
          history.replace("/login/");
        }

        if (res && res.LastEvaluatedKey) {
          setProjetopk(res.LastEvaluatedKey.pk);
          setProjetosk(res.LastEvaluatedKey.sk);
          setProjetogsi2sk(res.LastEvaluatedKey.gsi2sk);
          setDesabilitarInfiniteScroll(false);
        }
        else {
          setDesabilitarInfiniteScroll(true);
        }

        setArrayProjetos(res.Items);
        setShowLoading(false);
      });
    }
    consultar();
  }

  async function carregarMaisProjetos($event: CustomEvent<void>) {
    console.log("carregarMaisProjetos",);
    if (projetogsi2sk.includes(filtroStatusProjeto)) {
      await carregarMaisProjetosChamada().then(() => {
      });
    }
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  async function carregarMaisProjetosChamada() {
    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    const res: Response = await fetch(urlBaseCore.url + "/ordens?campo=" + (filtroCampoSelecionadoProjeto || "data") +
      "&valor=" + pkCliente.replaceAll(/#/g, "%23") +
      "&filtro=" + filtroStatusProjeto +
      "&isk=" + projetogsi2sk +
      "&pk=" + projetopk +
      "&sk=" + projetosk +
      "&lojas=" + Buffer.from(loja).toString('base64'),
      {
        method: urlBaseCore.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    await res
      .json()
      .then(async (projetos) => {

        if (projetos.Items) {
          for (let i = 0; i < projetos.Items.length; i++) {
            arrayProjetos.push(projetos.Items[i]);
          }

          if (projetos.LastEvaluatedKey) {
            setProjetopk(projetos.LastEvaluatedKey.pk);
            setProjetosk(projetos.LastEvaluatedKey.sk);
            setProjetogsi2sk(projetos.LastEvaluatedKey.gsi2sk);
            setDesabilitarInfiniteScroll(false);
          }
          else {
            setProjetopk("");
            setProjetosk("");
            setProjetogsi2sk("");
            setDesabilitarInfiniteScroll(true);
          }
        }

      })
      .catch(err => console.error(err));

    if (res.status === 400 || res.status === 401) history.replace("/login/");

  }

  function cadastrarTag() {

    if (!nomeTag) {
      setTextToast("Campo Nome é obrigatório.");
      setShowToast(true);
      return;
    }

    const objectRequest = {
      nome: nomeTag
    }
    console.log("objectRequest", objectRequest);

    let id = loja;

    console.log("id", id);

    requestService(
      empresaConfiguracoesAlterar.url.replace("{id}", id.replaceAll("#", "%23")).concat("?tag=endereco"),
      {
        method: empresaConfiguracoesAlterar.method,
        body: JSON.stringify(objectRequest),
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        console.log(response);
        if (response) {
          setTextToast("Cadastro realizado com sucesso.");
          setShowToast(true);

          setDadosEmpresa(response.message.Attributes);
          setListaTagsEndereco(response.message.Attributes.tagsEndereco || []);

          // carregarEmpresa();
          // setShowModalTags(false)
          setShowModalTagsAdd(false);

        } else if (response.status === 400) {
          console.log(response);
          setTextToast("Ocorreu um erro ao efetuar o cadastro. Tente novamente mais tarde.");
          setShowToast(true);

        }
        setShowLoading(false);
      },
      (error: any) => {
        console.log(error);
        setTextToast("Ocorreu um erro ao efetuar o cadastro. Tente novamente mais tarde.");
        setShowToast(true);
        setShowLoading(false);
      })
  }

  function handleClickCampoTelefone() {
    setTextToast("Digite o telefone na busca acima (ex: 11963927646)");
    setShowToast(true);
  }

  function handleClickCampoTrocoCalculado() {
    setTextToast("Digite o valor pago em dinheiro para calcular o troco automaticamente.");
    setShowToast(true);
  }

  return (
    <IonPage>

      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => {
              if (listaItemProdutos.length > 0) {
                mostartAlerta({
                  backdropDismiss: false,
                  header: 'Descartar ' + (window.localStorage.getItem("servicoTipo") || "Projeto"),
                  message: "Itens adicionados. Deseja descartar " + (window.localStorage.getItem("servicoTipo") || "Projeto") + "?",

                  buttons: [{
                    text: 'Cancelar',
                    role: 'cancel'
                  },
                  {
                    text: 'Confirmar',
                    handler: async () => {
                      history.goBack();
                    }
                  }],
                  onDidDismiss: () => { console.log('did dismiss'); }
                })
              }
              else { history.goBack(); }

            }
            } />
          </IonButtons>
          <IonTitle>Criar {(window.localStorage.getItem("servicoTipo") || "Projeto")}</IonTitle>

          <IonButtons slot="end">
            <IonButton onClick={openPopover}>
              <IonIcon slot="icon-only" icon={ellipsisVertical} />
            </IonButton>
          </IonButtons>

          <IonPopover
            isOpen={showPopover}
            event={popoverEvent}
            onDidDismiss={closePopover}
          >
            <IonList>


              <IonItem lines="none" button
                onClick={() => {
                  setShowModalTags(true); closePopover();
                }}>
                <IonIcon icon={pricetagsOutline} slot="start" />
                <IonLabel>Tags</IonLabel>
              </IonItem>

              <IonItem lines="none" button onClick={closePopover}>
                <IonIcon icon={closeOutline} slot="start" />
                <IonLabel>Cancelar</IonLabel>
              </IonItem>
            </IonList>
          </IonPopover>
        </IonToolbar>

      </IonHeader>
      <IonContent>
        <div>
          <IonCard>
            <IonCardContent>

              {/* <div style={{
                padding: "10px",
                backgroundColor: "#fff3cd",
                borderRadius: "8px",
                margin: "0px 8px 0px 8px",
                display: 'flex',
                alignItems: 'center'
              }}>
                <IonIcon icon={informationCircle} color="warning" style={{ marginRight: '10px', fontSize: '18px', minWidth: '18px' }} />
                <span style={{ fontSize: '12px' }}> Digite o telefone com DDD (ex: <strong>11963927646</strong>)</span>

              </div> */}



              <IonGrid style={{ padding: "0px", margin: "0px" }}>
                <IonRow>
                  <IonCol style={{ padding: "0px", margin: "0px" }} size="12" sizeMd="12">

                    <IonGrid style={{ padding: "0px", margin: "0px" }}>
                      <IonRow>
                        <IonCol style={{ padding: "0px", margin: "0px" }} size="12" sizeMd="10">
                          <IonSearchbar
                            ref={inputRef}
                            value={textoFiltro}
                            onIonChange={(e) => {
                              setTextoFiltro(e.detail.value);
                            }}
                            enterkeyhint="search"
                            onKeyUp={(e: any) => {
                              if (e.key === "Enter") {
                                setTimeout(() => {
                                  buscarCliente(e.target.value);
                                }, 500);
                              }
                            }}
                            placeholder="Digite o telefone com DDD (ex: 11963927646)"
                          />
                        </IonCol>
                        <IonCol style={{ display: 'flex', alignItems: 'center' }} size="12" sizeMd="2">
                          <IonButton
                            size="default"
                            onClick={() => {
                              if (textoFiltro) {
                                buscarCliente(textoFiltro);
                              }
                            }}
                            style={{ flex: 1, height: '44px', margin: '0px' }}
                          >
                            Buscar
                          </IonButton>
                          <IonButton
                            size="default"
                            color={!tipoAgendamento ? "danger" : "success"}
                            hidden={!dadosEmpresa.agendamento}
                            onClick={() => setShowModalAgendamento(true)}
                            style={{ width: '44px', height: '44px', margin: '0px 0px 0px 8px', minWidth: '44px', padding: '0px' }}
                          >
                            <IonIcon icon={calendarOutline} slot="icon-only" />
                          </IonButton>
                        </IonCol>
                      </IonRow>
                    </IonGrid>



                    <IonGrid>
                      <IonRow style={{ borderColor: 'grey', borderWidth: '1px', borderBottomStyle: 'solid' }}>
                        <IonCol style={{ padding: "0px", margin: "0px", fontSize: '25px' }} size="4">
                          <IonLabel><b>Cliente</b></IonLabel>

                        </IonCol>
                        <IonCol style={{ padding: "0px", margin: "0px", display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }} size="8">
                          <IonButton size="small" disabled={!pkCliente} onClick={() => {
                            carregarProjetosSegmentadaData("Encerrado", pkCliente);
                            setShowModalHistorico(true);
                          }}>Últimos Pedidos</IonButton>
                        </IonCol>
                      </IonRow>
                    </IonGrid>



                    <IonGrid style={{ padding: "0px", margin: "0px" }}>
                      <IonRow>
                        <IonCol style={{ padding: "0px", margin: "0px" }} size="12" sizeMd="4">
                          <IonItem lines="none">
                            <IonLabel position="stacked">Telefone*</IonLabel>
                            <IonInput
                              ref={(ref) => campoTelefone.current = ref}
                              type="tel"
                              readonly={true}
                              maxlength={15}
                              placeholder="(__) _____-____"
                              required
                              style={{ 'color': '#999', cursor: 'pointer' } as any}
                              value={telefone}
                              onClick={handleClickCampoTelefone}
                            />
                          </IonItem>
                        </IonCol>
                        <IonCol style={{ padding: "0px", margin: "0px" }} size="12" sizeMd="8">
                          <IonItem lines="none">
                            <IonLabel position="stacked">Nome*</IonLabel>
                            <IonInput
                              placeholder="Digite o nome completo"
                              value={nome}
                              autoCorrect='true'
                              autoCapitalize='true'
                              required
                              onIonInput={(e: any) => setNome(e.target.value)}
                            />

                          </IonItem>
                        </IonCol>

                      </IonRow>
                      <IonRow>
                        <IonCol style={{ padding: "0px", margin: "0px" }} size="9">
                          <IonItem lines="none">
                            <IonLabel position="stacked" style={{ marginBottom: '0px' }}>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ marginRight: '10px' }}>Endereço*</span>
                                <div
                                  style={{ display: 'flex', alignItems: 'center', pointerEvents: 'auto' }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <IonCheckbox
                                    checked={endereco === "RETIRADA"}
                                    onIonChange={(e: any) => {
                                      setEndereco(e.detail.checked ? "RETIRADA" : "");
                                      setEnderecoLat("");
                                      setEnderecoLng("");
                                    }}
                                    style={{ margin: '0 8px 0 0', width: '16px', height: '16px' }}
                                  />
                                  <span style={{ fontSize: '14px', color: '#666' }}>RETIRADA</span>
                                </div>
                                {buscandoEndereco && dadosEmpresa?.tipoConfiguracoesEntrega === "raio" && (
                                  <span style={{ fontSize: '12px', color: '#999', marginLeft: '8px' }}>
                                    (buscando...)
                                  </span>
                                )}
                              </div>
                            </IonLabel>
                            <IonInput
                              value={endereco}
                              autoCorrect='true'
                              autoCapitalize='true'
                              placeholder="Avenida Paulista, 111, São Paulo"
                              onIonInput={(e: any) => {
                                const valor = e.target.value;
                                setEndereco(valor);

                                // Busca automática apenas para raio
                                if (dadosEmpresa?.tipoConfiguracoesEntrega === "raio") {
                                  buscarSugestoesEndereco(valor);
                                }
                              }}
                              enterkeyhint="search"
                              onKeyDown={(e: any) => {
                                // Enter apenas para raio
                                if (e.key === "Enter" && dadosEmpresa?.tipoConfiguracoesEntrega === "raio") {
                                  e.preventDefault();
                                  const valor = endereco || '';
                                  if (valor.trim().length >= 4) {
                                    buscarSugestoesEndereco(valor, true);
                                  } else {
                                    setTextToast('Digite no mínimo 4 caracteres para buscar.');
                                    setShowToast(true);
                                  }
                                }
                              }}
                            />
                          </IonItem>
                        </IonCol>
                        <IonCol style={{ padding: "0px", margin: "0px" }} size="3">
                          <IonItem lines="none">
                            {dadosEmpresa?.tipoConfiguracoesEntrega === "raio" ? (
                              <IonIcon slot="end" size="large" color="primary" icon={map} onClick={() => { setShowDetalhesEndereco(true); }} />
                            ) : (
                              <>
                                <IonLabel position="stacked">Bairro</IonLabel>
                                <IonSelect
                                  placeholder="Selecione"
                                  value={bairroSelecionado}
                                  onIonChange={(e) => onBairroSelecionado(e.detail.value)}
                                >
                                  {getBairrosConfiguracoes().map((config: any, index: number) => (
                                    <IonSelectOption key={index} value={config.bairro}>
                                      {config.bairro}
                                    </IonSelectOption>
                                  ))}
                                </IonSelect>
                              </>
                            )}
                          </IonItem>
                        </IonCol>
                      </IonRow>

                      {/* Lista de sugestões de endereço - apenas para raio */}
                      {dadosEmpresa?.tipoConfiguracoesEntrega === "raio" && listaEnderecos?.length > 0 && (
                        <IonRow>
                          <IonCol size="12" style={{ padding: "0px 8px" }}>
                            {/* {console.log("Renderizando lista com", listaEnderecos.length, "itens")} */}
                            <IonList
                              style={{
                                padding: '0px',
                                width: '100%',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                backgroundColor: '#fff',
                                maxHeight: '197px',
                                overflowY: 'auto',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                              }}
                            >
                              {listaEnderecos.map((item: any, index: any) => {
                                // console.log("Item da lista:", item);
                                return (
                                  <IonItem
                                    lines={index < listaEnderecos.length - 1 ? "full" : "none"}
                                    key={"sugestao" + index}
                                    button
                                    onClick={() => handleSelectItemSugestaoEndereco(item)}
                                  >
                                    <IonIcon
                                      icon={locationOutline}
                                      slot="start"
                                      color='primary'
                                      style={{ fontSize: '20px', marginRight: '12px' }}
                                    />
                                    <IonLabel style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                      <div style={{ fontWeight: '600', fontSize: '15px', marginBottom: '4px', color: '#333' }}>
                                        {item.descricaoPrincipal}
                                      </div>
                                      <div style={{ fontSize: '13px', color: '#999' }}>
                                        {item.descricaoSecundaria}
                                      </div>
                                    </IonLabel>
                                  </IonItem>
                                );
                              })}
                            </IonList>
                          </IonCol>
                        </IonRow>
                      )}

                      <IonRow style={{ paddingLeft: "8px", paddingRight: "8px" }}>
                        {listaTagsEndereco?.map((opcao: any, index: any) => (
                          <IonCol size="auto" key={index}> {/* size="6" coloca 2 botões por linha */}
                            <IonButtons>
                              <IonButton
                                fill="outline"
                                style={{ height: "26px", fontSize: "12px" }}
                                expand="block"
                                shape="round"
                                color="primary"
                                onClick={() => {
                                  setEndereco(endereco + opcao);
                                  // setTimeout(() => {
                                  //   buscarLocalizacao(endereco + opcao);
                                  // }, 500);
                                }}
                              >
                                {opcao.toUpperCase()}
                              </IonButton>
                            </IonButtons>
                          </IonCol>


                        ))}

                      </IonRow>

                      <IonRow>
                        <IonCol style={{ padding: "0px", margin: "0px" }} size="12">
                          <IonItem lines="none">
                            <IonLabel position="stacked">Complemento</IonLabel>
                            <IonInput
                              value={complemento}
                              autoCorrect='true'
                              autoCapitalize='true'
                              placeholder="Apartamento, bloco, etc."
                              onIonInput={(e: any) => setComplemento(e.target.value)}
                            />
                          </IonItem>
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonCardContent>
          </IonCard>

        </div>

        <IonGrid style={{ padding: "0px", margin: "0px" }} ref={contentCatalogoRef}>
          <IonRow>

            <IonCol style={{ padding: "0px", margin: "0px" }} sizeMd="8" size="12">

              <OrdensProdutosCompor
                empresa={dadosEmpresa}
                disabled={false}
                adicionarItem={adicionarItem}
                reload={reloadCatalogo}
                onReloadComplete={() => { setReloadCatalogo(false); }}
              />

            </IonCol>

            <IonCol style={{ padding: "0px", margin: "0px" }} sizeMd="4" size="12">
              <IonCard>
                <IonCardContent>

                  <IonGrid style={{ padding: "0px", margin: "0px" }}>

                    <IonRow style={{ borderColor: 'grey', fontSize: '25px', borderWidth: '1px', borderBottomStyle: 'solid' }}>
                      <IonCol style={{ padding: "0px", margin: "0px" }} size="8"><IonLabel><b>Lista de itens</b></IonLabel></IonCol>
                      <IonCol style={{ padding: "0px", margin: "0px" }} size="4"><IonLabel style={{ display: 'block', textAlign: "right" }}><b>{valorTotalProdutos}</b></IonLabel></IonCol>

                    </IonRow>

                  </IonGrid>

                  {loadItemProdutos2()}

                  <IonGrid style={{ margin: "0px" }}>
                    <IonRow style={{ borderColor: 'grey', fontSize: '25px', borderWidth: '1px', borderBottomStyle: 'solid' }}>
                      <IonCol style={{ padding: "0px", margin: "0px" }} size="12"><IonLabel><b>Pagamento</b></IonLabel></IonCol>
                    </IonRow>
                  </IonGrid>


                  <IonGrid style={{ padding: "0px", margin: "0px" }}>
                    <IonRow>
                      <IonCol>
                        <IonList>
                          <IonItem lines="none">
                            <IonLabel position="stacked">Forma de pagamento*</IonLabel>
                            <IonSelect
                              placeholder="Selecione"
                              value={formaPagamento}
                              onIonChange={(e) => {
                                setFormaPagamento(e.detail.value);
                              }}
                            >
                              {dadosEmpresa.formaPagamento?.map((item: any, index: any) => {
                                if (!item.exibirPdv || item.tipo == "Mercado Pago" || item.tipo == "InfinitePay") return null;

                                return (
                                  <IonSelectOption key={index} value={item.nome}>
                                    {item.nome.toUpperCase()}
                                  </IonSelectOption>
                                );
                              })}

                            </IonSelect>
                          </IonItem>

                          <IonItem lines="none" hidden={formaPagamento != "Dinheiro"}>
                            <IonLabel position="stacked">Valor pago em dinheiro</IonLabel>
                            <IonInput
                              type="tel"
                              maxlength={14}
                              placeholder="Digite o valor pago"
                              value={valorPagoDinheiro}
                              onKeyUp={onChangeValor}
                            />
                          </IonItem>

                          <IonItem lines="none" hidden={formaPagamento != "Dinheiro"}>
                            <IonLabel position="stacked">Troco calculado</IonLabel>
                            <IonInput
                              readonly={true}
                              value={troco || '0,00'}
                              style={{ 'color': '#999', cursor: 'pointer' } as any}
                              onClick={handleClickCampoTrocoCalculado}
                            />
                          </IonItem>

                          <IonItem lines="none">
                            <IonLabel position="stacked">Taxa de entrega*</IonLabel>
                            <IonSelect
                              placeholder="Selecione"
                              value={taxaEntrega}
                              onIonChange={(e) => setTaxaEntrega(e.detail.value)}
                            >
                              {opcoesTaxaEntrega.map((opcao, index) => (
                                <IonSelectOption key={index} value={opcao.value}>
                                  {opcao.label}
                                </IonSelectOption>
                              ))}
                            </IonSelect>
                          </IonItem>

                          <IonItem lines="none">
                            <IonLabel position="stacked">Desconto</IonLabel>
                            <IonSelect
                              placeholder="Selecione"
                              value={desconto}
                              onIonChange={(e) => setDesconto(e.detail.value)}
                            >
                              {opcoesDesconto.map((opcao, index) => (
                                <IonSelectOption key={index} value={opcao.value}>
                                  {opcao.label}
                                </IonSelectOption>
                              ))}
                            </IonSelect>
                          </IonItem>
                        </IonList>
                      </IonCol>
                    </IonRow>
                  </IonGrid>

                  <IonGrid style={{ padding: "0px", margin: "0px" }}>
                    <IonRow style={{ borderColor: 'grey', fontSize: '25px', borderWidth: '1px', borderTopStyle: 'solid' }}>
                      <IonCol><IonLabel><b>Total</b></IonLabel></IonCol>
                      <IonCol><IonLabel style={{ display: 'block', textAlign: "right" }}><b>{valorTotal}</b></IonLabel></IonCol>
                    </IonRow>
                  </IonGrid>


                  <IonToolbar>
                    <IonButton
                      onClick={async () => {
                        avancar();
                      }}
                      expand="block"
                      type="submit"
                    >
                      Registrar
                    </IonButton>
                  </IonToolbar>


                </IonCardContent>
              </IonCard>
            </IonCol>

          </IonRow>
        </IonGrid>




        {/* <IonModal
          onDidPresent={() => {
            if (inputRefEndereco.current) {
              inputRefEndereco.current.setFocus();
            }
          }} isOpen={showDetalhesEndereco} onDidDismiss={() => { setShowDetalhesEndereco(false); }}>
          <Endereco endereco={endereco} inputRef={inputRefEndereco} closeAction={closeModalEndereco} closeActionSimple={closeModalSimpleEndereco}></Endereco>
        </IonModal> */}


        <IonModal
          className="small-modal"
          isOpen={showModalAgendamento}
          onDidDismiss={() => { setShowModalAgendamento(false); }}
          style={{
            '--backdrop-opacity': '0.4',              // opacidade do cinza
            '--backdrop-background': 'rgba(0,0,0,0.4)' // cor exata do overlay
          }}
        >
          <Agendamento
            closeActionSimple={closeModalAgendamentoSimple}
            closeAction={closeModalAgendamento}
            initialData={tipoAgendamento === "AGENDADO" ? dataAgendamento : ""}
            initialHora={tipoAgendamento === "AGENDADO" ? horaAgendamento : ""}
          ></Agendamento>
        </IonModal>

        <IonModal className="fullscreen-modal"
          onDidPresent={() => {
            if (inputRefEndereco.current) {
              inputRefEndereco.current.setFocus();
            }
          }} isOpen={showDetalhesEndereco} onDidDismiss={() => { setShowDetalhesEndereco(false); }}>
          <EnderecoTaxa endereco={endereco} inputRef={inputRefEndereco} closeAction={closeModalEndereco} closeActionSimple={closeModalSimpleEndereco}></EnderecoTaxa>
        </IonModal>


        <IonModal isOpen={showModalTags} onDidDismiss={() => { setShowModalTags(false); }}>
          <IonHeader className="ion-no-border">

            <IonToolbar>
              <IonButtons slot="start">
                <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowModalTags(false)} />
              </IonButtons>
              <IonTitle>Tags</IonTitle>

            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonGrid>
              <IonRow>
                <IonCol size="12">

                  <IonList>
                    {loadTagsEndereco()}
                  </IonList>

                  <IonModal onDidPresent={() => {
                    if (inputRefTag.current) {
                      inputRefTag.current.setFocus();
                    }
                  }} isOpen={showModalTagsAdd} onDidDismiss={() => {
                    setShowModalTagsAdd(false);
                    setNome("");
                  }}>


                    <>
                      <IonHeader className="ion-no-border">
                        <IonToolbar>
                          <IonButtons slot="start">
                            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowModalTagsAdd(false)} />
                          </IonButtons>
                          <IonTitle>Nova tag</IonTitle>
                        </IonToolbar>
                      </IonHeader>
                      <IonContent>
                        <IonGrid>
                          <IonRow>
                            <IonCol>
                              <IonList>

                                <IonItem lines="none">
                                  <IonLabel position="stacked">Nome*</IonLabel>
                                  <IonInput placeholder="Digite o nome da tag" value={nomeTag} ref={(ref) => inputRefTag.current = ref} autoCorrect='true' autoCapitalize='true' required onIonInput={(e: any) => setNomeTag(e.target.value)}></IonInput>
                                </IonItem>
                              </IonList>
                            </IonCol>
                          </IonRow>
                        </IonGrid>

                      </IonContent>
                      <IonFooter className="ion-no-border">
                        <IonToolbar>
                          <IonButton onClick={() => cadastrarTag()} expand="block" type="submit">Cadastrar</IonButton>
                        </IonToolbar>
                      </IonFooter>
                    </>

                  </IonModal>

                  <IonInfiniteScroll
                    threshold="100px"
                    onIonInfinite={(e: CustomEvent<void>) => carregarMaisProjetos(e)}
                    position="bottom"
                    disabled={desabilitarInfiniteScroll}
                  >
                    <IonInfiniteScrollContent
                      loadingSpinner="dots"
                      loadingText="Carregando mais itens..."
                    ></IonInfiniteScrollContent>
                  </IonInfiniteScroll>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonContent>
          <IonFooter className="ion-no-border">
            <IonToolbar>
              <IonButton onClick={() => { setNomeTag(""); setShowModalTagsAdd(true); }} expand="block" type="submit">Nova</IonButton>
            </IonToolbar>
          </IonFooter>

        </IonModal>


        {/* Modal que contém a lista de pedidos */}
        <IonModal isOpen={showModalHistorico} onDidDismiss={() => { setShowModalHistorico(false); }}>
          <IonHeader className="ion-no-border">

            <IonToolbar>
              <IonButtons slot="start">
                <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowModalHistorico(false)} />
              </IonButtons>
              <IonTitle>Histórico de Pedidos</IonTitle>

            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonGrid>
              <IonRow>
                <IonCol size="12">
                  <div>
                    {loadItensHistorico()}
                  </div>

                  <IonInfiniteScroll
                    threshold="100px"
                    onIonInfinite={(e: CustomEvent<void>) => carregarMaisProjetos(e)}
                    position="bottom"
                    disabled={desabilitarInfiniteScroll}
                  >
                    <IonInfiniteScrollContent
                      loadingSpinner="dots"
                      loadingText="Carregando mais itens..."
                    ></IonInfiniteScrollContent>
                  </IonInfiniteScroll>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonContent>

        </IonModal>

      </IonContent>



      <IonToast
        isOpen={showToast}
        position="middle" //top, bottom, middle
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={3000}
      />


      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoading}
        onDidDismiss={() => { setShowLoading(false); }}
        spinner='circles'
      />

    </IonPage >
  );
};

export default OrdensNovoPedido;
